(function () {
  const WISHLIST_KEY = 'gvfg_wishlist';
  const RECENT_KEY = 'gvfg_recent';

  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => [...root.querySelectorAll(sel)];

  const shopRoot = () => {
    const root = window.GVFG?.routes?.root || '/';
    return root.endsWith('/') ? root : `${root}/`;
  };

  const productPath = (handle) => `${shopRoot()}products/${handle}`;

  const sizedCdnImage = (url, width = 280) => {
    if (!url || typeof url !== 'string') return url || '';
    if (!/(cdn\.shopify|\/cdn\/shop\/)/i.test(url)) return url;
    const sep = url.includes('?') ? '&' : '?';
    return `${url}${sep}width=${width}&format=webp`;
  };

  const createVisibilityInterval = (callback, intervalMs) => {
    let timer = null;
    const stop = () => {
      if (!timer) return;
      clearInterval(timer);
      timer = null;
    };
    const start = () => {
      stop();
      if (document.hidden) return;
      timer = setInterval(callback, intervalMs);
    };
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
    start();
    return { start, stop };
  };

  const getWishlist = () => {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); } catch (_) { return []; }
  };
  const setWishlist = (list) => localStorage.setItem(WISHLIST_KEY, JSON.stringify(list.slice(0, 50)));
  const updateWishlistBadge = () => {
    const badge = document.getElementById('wishlistBadge');
    if (!badge) return;
    const count = getWishlist().length;
    badge.textContent = count;
    badge.hidden = count === 0;
  };
  const isWishlisted = (handle) => getWishlist().includes(handle);
  const isProductAvailable = product => product?.available !== false;

  const purgeUnavailableWishlist = async () => {
    const handles = getWishlist();
    if (!handles.length) return [];
    const products = await Promise.all(handles.map(h =>
      fetch(`/products/${h}.js`).then(r => r.ok ? r.json() : null).catch(() => null)
    ));
    const valid = handles.filter((h, i) => isProductAvailable(products[i]));
    if (valid.length !== handles.length) setWishlist(valid);
    return valid;
  };

  const toggleWishlist = (handle) => {
    let list = getWishlist().filter(h => h !== handle);
    if (!getWishlist().includes(handle)) list.unshift(handle);
    setWishlist(list);
    updateWishlistBadge();
    syncWishlistButtons();
    refreshWishlistDrawer();
    return list.includes(handle);
  };

  const renderWishlistDrawerItem = (p) => {
    const variant = p.variants?.find(v => v.available) || p.variants?.[0];
    const price = variant?.price ?? p.price;
    const img = p.featured_image || p.images?.[0];
    const available = isProductAvailable(p) && variant?.available !== false;
    const title = p.title.replace(/"/g, '&quot;');
    return `
      <article class="wishlist-drawer-item" data-wishlist-item="${p.handle}">
        <a href="/products/${p.handle}" class="wishlist-drawer-item-media">
          ${img
            ? `<img src="${img}" alt="${title}" loading="lazy" width="80" height="107">`
            : '<span class="wishlist-drawer-item-placeholder" aria-hidden="true"></span>'}
        </a>
        <div class="wishlist-drawer-item-details">
          <a href="/products/${p.handle}" class="wishlist-drawer-item-title">${p.title}</a>
          <span class="wishlist-drawer-item-price">${formatMoney(price)}</span>
          <div class="wishlist-drawer-item-actions">
            ${available
              ? `<button type="button" class="btn wishlist-drawer-atc" data-wishlist-atc data-variant-id="${variant.id}" data-inventory-managed="${variant.inventory_management || ''}" data-inventory-quantity="${variant.inventory_quantity ?? ''}">${window.GVFG?.addToCart || 'Add to cart'}</button>`
              : '<span class="wishlist-drawer-soldout">Sold out</span>'}
            <button type="button" class="wishlist-drawer-remove" data-wishlist-remove="${p.handle}">Remove</button>
          </div>
        </div>
      </article>`;
  };

  const refreshWishlistDrawer = () => {
    const drawer = document.getElementById('wishlistDrawer');
    if (!drawer || drawer.hidden || !drawer.classList.contains('open')) return;
    renderWishlistDrawer();
  };

  const renderWishlistDrawer = async () => {
    const body = document.getElementById('wishlistDrawerBody');
    if (!body) return;
    const handles = getWishlist();
    if (!handles.length) {
      body.innerHTML = `<p class="wishlist-drawer-empty">${window.GVFG?.wishlistEmpty || 'Your wishlist is empty.'}</p>`;
      return;
    }
    body.innerHTML = `<p class="wishlist-drawer-loading">${window.GVFG?.wishlistLoading || 'Loading wishlist…'}</p>`;
    const products = await Promise.all(handles.map(h =>
      fetch(`/products/${h}.js`).then(r => r.ok ? r.json() : null).catch(() => null)
    ));
    const valid = products.filter(p => p && isProductAvailable(p));
    if (valid.length !== handles.length) {
      setWishlist(valid.map(p => p.handle));
      updateWishlistBadge();
      syncWishlistButtons();
    }
    if (!valid.length) {
      body.innerHTML = `<p class="wishlist-drawer-empty">${window.GVFG?.wishlistEmpty || 'Your wishlist is empty.'}</p>`;
      return;
    }
    body.innerHTML = `<div class="wishlist-drawer-list">${valid.map(renderWishlistDrawerItem).join('')}</div>`;
  };

  const openWishlistDrawer = () => {
    const drawer = document.getElementById('wishlistDrawer');
    if (!drawer) return;
    drawer.hidden = false;
    requestAnimationFrame(() => drawer.classList.add('open'));
    document.body.style.overflow = 'hidden';
    renderWishlistDrawer();
  };

  const closeWishlistDrawer = () => {
    const drawer = document.getElementById('wishlistDrawer');
    if (!drawer) return;
    drawer.classList.remove('open');
    document.body.style.overflow = '';
    window.setTimeout(() => {
      if (!drawer.classList.contains('open')) drawer.hidden = true;
    }, 300);
  };

  const syncWishlistButtons = () => {
    qsa('.wishlist-add[data-product-handle]').forEach(btn => {
      const active = isWishlisted(btn.dataset.productHandle);
      btn.classList.toggle('active', active);
      if (btn.classList.contains('product-wishlist-icon')) {
        btn.setAttribute('aria-label', active ? 'Added to wishlist' : 'Add to wishlist');
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      }
    });
  };

  const formatMoney = (cents) => {
    const amount = Number(cents);
    if (!Number.isFinite(amount)) return '';
    if (window.Shopify?.formatMoney) return Shopify.formatMoney(amount);
    const format = window.GVFG?.moneyFormat;
    if (format) {
      const value = (amount / 100).toFixed(2);
      const parts = value.split('.');
      const withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const formatted = `${withCommas}.${parts[1]}`;
      return format
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, parts[0])
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, `${withCommas},${parts[1]}`)
        .replace(/\{\{\s*amount\s*\}\}/g, formatted)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    }
    return 'Rs.' + (amount / 100).toLocaleString();
  };

  const renderPriceContents = (price, compare) => {
    const currentPrice = Number(price) || 0;
    const originalPrice = Number(compare) || 0;
    const onSale = originalPrice > currentPrice;
    const discount = onSale ? Math.round((1 - currentPrice / originalPrice) * 100) : 0;
    const showInlineDiscount = window.GVFG?.card?.showInlineDiscount !== false;
    return `${onSale ? `<span class="compare-price">${formatMoney(originalPrice)}</span>${showInlineDiscount ? `<span class="discount">-${discount}%</span>` : ''}` : ''}<span class="sale-price">${formatMoney(currentPrice)}</span>`;
  };

  const normalizePhoneDigits = (value) => String(value || '').replace(/\D/g, '');

  const isValidCartPhone = (value) => {
    const digits = normalizePhoneDigits(value);
    return /^(?:0?3\d{9}|923\d{9})$/.test(digits);
  };

  const getActiveCartPhoneInput = () => {
    const drawer = document.getElementById('cartDrawer');
    const drawerInput = drawer && !drawer.hidden ? drawer.querySelector('[data-cart-phone-input]') : null;
    if (drawerInput) return drawerInput;
    return document.querySelector('[data-cart-page] [data-cart-phone-input]') || document.querySelector('[data-cart-phone-input]');
  };

  const setCartPhoneFieldState = (input, valid) => {
    if (!input) return;
    const field = input.closest('[data-cart-phone-field]');
    const error = field?.querySelector('[data-cart-phone-error]');
    input.classList.toggle('is-invalid', !valid);
    if (error) error.hidden = valid;
  };

  const saveCartPhone = (value) =>
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { Phone: String(value || '').trim() } })
    }).then(r => (r.ok ? r.json() : Promise.reject()));

  const requireCartPhone = () => {
    const input = getActiveCartPhoneInput();
    if (!input) return true;
    const valid = isValidCartPhone(input.value);
    setCartPhoneFieldState(input, valid);
    if (!valid) input.focus();
    return valid;
  };

  const renderCartPhoneField = (value = '', inputId = 'CartDrawerPhone') => {
    const cfg = window.GVFG || {};
    return `
      <div class="cart-phone-field cart-phone-field--drawer" data-cart-phone-field>
        <label for="${inputId}">${cfg.cartPhoneLabel || 'Phone number'} <span class="required" aria-hidden="true">*</span></label>
        <input
          type="tel"
          id="${inputId}"
          name="attributes[Phone]"
          class="cart-phone-input"
          data-cart-phone-input
          value="${escapeHtml(value)}"
          placeholder="${escapeHtml(cfg.cartPhonePlaceholder || '03XX XXXXXXX')}"
          autocomplete="tel"
          inputmode="tel"
          required
          aria-required="true"
        >
        <p class="cart-phone-error" data-cart-phone-error hidden>${cfg.cartPhoneRequired || 'Please enter a valid phone number before checkout.'}</p>
      </div>`;
  };

  const escapeHtml = (value) => String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

  const updateCartBadges = (count) => {
    const badge = document.getElementById('cartBadge');
    const bottomBadge = document.getElementById('bottomCartBadge');
    [badge, bottomBadge].forEach(el => {
      if (!el) return;
      el.textContent = count;
      el.hidden = count <= 0;
    });
  };

  const cartItemCountLabel = (count) => {
    const cfg = window.GVFG || {};
    if (count === 1) return cfg.cartItemCountOne || '1 item';
    const tpl = cfg.cartItemCountOther || '__COUNT__ items';
    return tpl.replace('__COUNT__', String(count));
  };

  // Several product widgets ask for the cart at the same time.  Keep one short-lived
  // snapshot so a browsing session does not create repeated identical cart requests.
  let cartSnapshot = null;
  let cartSnapshotAt = 0;
  let cartRequest = null;
  const CART_SNAPSHOT_TTL = 1200;

  const cacheCart = (cart) => {
    cartSnapshot = cart;
    cartSnapshotAt = Date.now();
    return cart;
  };

  const invalidateCartSnapshot = () => {
    cartSnapshot = null;
    cartSnapshotAt = 0;
  };

  const fetchCart = ({ force = false } = {}) => {
    const freshSnapshot = cartSnapshot && (Date.now() - cartSnapshotAt) < CART_SNAPSHOT_TTL;
    if (!force && freshSnapshot) return Promise.resolve(cartSnapshot);
    if (cartRequest) return cartRequest;

    cartRequest = fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(cacheCart)
      .finally(() => { cartRequest = null; });
    return cartRequest;
  };

  const changeCartLine = (key, quantity) =>
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    }).then(r => r.ok ? r.json() : Promise.reject())
      .then(cacheCart);

  const addToCartRequest = (variantId, quantity = 1) =>
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId) || variantId, quantity })
    }).then(async r => {
      const data = await r.json().catch(() => ({}));
      if (!r.ok) return Promise.reject(data);
      invalidateCartSnapshot();
      return data;
    });

  const productVariantCache = new Map();
  const variantInventoryCache = new Map();
  const productInventoryPageCache = new Map();
  let productInventoryMapCache = null;

  const getProductInventoryMap = () => {
    if (productInventoryMapCache) return productInventoryMapCache;
    const el = document.getElementById('ProductInventoryJSON');
    if (!el) return null;
    try {
      productInventoryMapCache = JSON.parse(el.textContent);
      Object.entries(productInventoryMapCache || {}).forEach(([id, meta]) => cacheVariantInventory(id, meta));
      return productInventoryMapCache;
    } catch (_) {
      return null;
    }
  };

  const cacheVariantInventory = (variantId, meta) => {
    if (!variantId || !meta) return;
    variantInventoryCache.set(String(variantId), {
      inventory_management: meta.inventory_management ?? '',
      inventory_quantity: meta.inventory_quantity,
      available: meta.available
    });
  };

  const readInventoryFromElement = (el) => {
    if (!el) return null;
    const variantId = el.dataset.variantId
      || el.dataset.quickViewVariantId
      || el.querySelector('[data-variant-id]')?.value
      || el.querySelector('[name="id"]')?.value;
    const managed = el.dataset.inventoryManaged || el.dataset.quickViewInventoryManaged || '';
    const quantity = el.dataset.inventoryQuantity ?? el.dataset.quickViewInventoryQuantity;
    if (!variantId) return null;
    if (managed !== 'shopify' && (quantity === undefined || quantity === '')) return null;
    return {
      variantId: String(variantId),
      meta: {
        inventory_management: managed,
        inventory_quantity: quantity
      }
    };
  };

  const seedVariantInventoryCache = (root = document) => {
    qsa('[data-add-to-cart-card], [data-quick-view-atc], [data-add-to-cart]', root).forEach(el => {
      const data = readInventoryFromElement(el);
      if (data) cacheVariantInventory(data.variantId, data.meta);
    });
    qsa('[data-quick-view]', root).forEach(el => {
      const data = readInventoryFromElement(el);
      if (data) cacheVariantInventory(data.variantId, data.meta);
    });
  };

  const fetchProductInventoryMap = async (handle) => {
    if (!handle) return null;
    if (productInventoryPageCache.has(handle)) return productInventoryPageCache.get(handle);
    try {
      const html = await fetch(`/products/${handle}`, { headers: { Accept: 'text/html' } }).then(r => (r.ok ? r.text() : ''));
      if (!html) return null;
      const match = html.match(/id="ProductInventoryJSON">\s*(\{[\s\S]*?\})\s*<\/script>/);
      if (match) {
        const map = JSON.parse(match[1]);
        productInventoryPageCache.set(handle, map);
        Object.entries(map).forEach(([id, meta]) => cacheVariantInventory(id, meta));
        return map;
      }
      const variantId = html.match(/data-variant-id="(\d+)"/)?.[1];
      const managed = html.match(/data-inventory-managed="([^"]*)"/)?.[1] || '';
      const qty = html.match(/data-inventory-quantity="(\d+)"/)?.[1];
      if (variantId && managed === 'shopify' && qty != null) {
        const map = {
          [variantId]: {
            inventory_management: managed,
            inventory_quantity: parseInt(qty, 10)
          }
        };
        productInventoryPageCache.set(handle, map);
        cacheVariantInventory(variantId, map[variantId]);
        return map;
      }
    } catch (_) {}
    productInventoryPageCache.set(handle, null);
    return null;
  };

  const getVariantInventoryMeta = (variantId) => {
    if (!variantId) return null;
    const id = String(variantId);
    const pageMap = getProductInventoryMap();
    if (pageMap?.[id]) return pageMap[id];
    return variantInventoryCache.get(id) || null;
  };

  const getCartQtyForVariant = (cart, variantId) => {
    const id = String(variantId);
    const item = (cart?.items || []).find(i => String(i.variant_id) === id);
    return item ? item.quantity : 0;
  };

  const isInventoryTracked = (source) =>
    source?.inventory_management === 'shopify' || source?.dataset?.inventoryManaged === 'shopify';

  const parseInventoryQuantity = (value) => {
    if (value === null || value === undefined || value === '') return null;
    const qty = parseInt(value, 10);
    return Number.isNaN(qty) ? null : Math.max(0, qty);
  };

  const getVariantInventoryMax = (source, variantId = '') => {
    const id = String(variantId || source?.id || source?.dataset?.variantId || '');
    const meta = id ? getVariantInventoryMeta(id) : null;
    if (meta?.inventory_management === 'shopify') {
      const qty = parseInventoryQuantity(meta.inventory_quantity);
      if (qty !== null) return qty;
    }

    if (source?.dataset?.inventoryManaged === 'shopify') {
      const qty = parseInventoryQuantity(source.dataset.inventoryQuantity);
      if (qty !== null) return qty;
    }

    if (source && typeof source === 'object' && source.inventory_management === 'shopify') {
      const qty = parseInventoryQuantity(source.inventory_quantity);
      if (qty !== null) return qty;
    }

    return null;
  };

  const getRemainingCartQty = (cart, variantId, maxInventory) => {
    if (maxInventory === null) return Infinity;
    return Math.max(0, maxInventory - getCartQtyForVariant(cart, variantId));
  };

  const fetchProductVariant = async (handle, variantId) => {
    const cacheKey = `${handle}:${variantId}`;
    if (productVariantCache.has(cacheKey)) return productVariantCache.get(cacheKey);
    const product = await fetch(`/products/${handle}.js`).then(r => (r.ok ? r.json() : null)).catch(() => null);
    const variant = product?.variants?.find(v => String(v.id) === String(variantId)) || null;
    productVariantCache.set(cacheKey, variant);
    return variant;
  };

  const resolveVariantInventoryMax = async (variantId, source, handle = '') => {
    const fromKnownSources = getVariantInventoryMax(source, variantId);
    if (fromKnownSources !== null) return fromKnownSources;

    const meta = getVariantInventoryMeta(variantId);
    if (meta?.inventory_management === 'shopify') {
      const qty = parseInventoryQuantity(meta.inventory_quantity);
      if (qty !== null) return qty;
    }

    if (handle) {
      await fetchProductInventoryMap(handle);
      const fetchedMeta = getVariantInventoryMeta(variantId);
      if (fetchedMeta?.inventory_management === 'shopify') {
        const qty = parseInventoryQuantity(fetchedMeta.inventory_quantity);
        if (qty !== null) return qty;
      }
    }
    return null;
  };

  const getAtcDefaultLabel = () => window.GVFG?.addToCart || 'Add to cart';

  const ensureAtcLabelDefault = (btn) => {
    if (!btn) return;
    const current = btn.textContent.trim();
    if (!btn.dataset.labelDefault || btn.dataset.labelDefault === 'Adding…' || current === 'Adding…') {
      btn.dataset.labelDefault = getAtcDefaultLabel();
    }
  };

  const isDrawerAtcButton = (btn) =>
    btn?.matches('[data-add-to-cart-card], [data-wishlist-atc], [data-quick-view-atc]');

  const markAtcButtonAdded = (btn) => {
    if (!btn) return;
    ensureAtcLabelDefault(btn);
    btn.textContent = window.GVFG?.cartAddedToCart || 'Added to cart';
    btn.classList.add('is-added');
    if (isDrawerAtcButton(btn)) {
      btn.disabled = false;
      btn.removeAttribute('aria-disabled');
      btn.setAttribute('aria-label', `${window.GVFG?.cartAddedToCart || 'Added to cart'} — ${window.GVFG?.cartOpen || 'Open cart'}`);
    } else {
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
    }
  };

  const resetAtcButton = (btn) => {
    if (!btn) return;
    ensureAtcLabelDefault(btn);
    btn.textContent = btn.dataset.labelDefault || getAtcDefaultLabel();
    btn.classList.remove('is-added');
    btn.disabled = false;
    btn.removeAttribute('aria-disabled');
  };

  const isSingleQtyAtcContext = (btn, maxInv, qtyInput) => {
    if (!btn) return false;
    if (maxInv === 1) return true;
    const qtyMax = parseInt(qtyInput?.max || '', 10);
    return btn.matches('[data-add-to-cart]') && qtyMax === 1;
  };

  const shouldMarkAtcAdded = (btn, inCart, remaining, maxInv, qtyInput) =>
    inCart > 0 && (remaining === 0 || isSingleQtyAtcContext(btn, maxInv, qtyInput));

  const finalizeAtcButtonState = async (btn, variantId, source, handle = '') => {
    if (!btn || !variantId) return null;
    const cart = await fetchCart();
    const maxInv = await resolveVariantInventoryMax(variantId, source || btn, handle);
    const inCart = getCartQtyForVariant(cart, variantId);
    const remaining = getRemainingCartQty(cart, variantId, maxInv);
    const qtyInput = btn.closest('form')?.querySelector('[data-product-qty]') || document.getElementById('Quantity');
    if (shouldMarkAtcAdded(btn, inCart, remaining, maxInv, qtyInput)) markAtcButtonAdded(btn);
    else if (!btn.classList.contains('is-added')) resetAtcButton(btn);
    return cart;
  };

  const resolveAtcButtonAfterAdd = async (btn, variantId, source, handle = '') => {
    if (!btn || !variantId) return null;
    try {
      return await finalizeAtcButtonState(btn, variantId, source, handle);
    } catch (_) {
      if (!btn.classList.contains('is-added')) resetAtcButton(btn);
      return null;
    } finally {
      if (btn.textContent.trim() === 'Adding…') {
        try {
          await finalizeAtcButtonState(btn, variantId, source, handle);
        } catch (_) {
          if (!btn.classList.contains('is-added')) resetAtcButton(btn);
        }
      }
    }
  };

  const syncCartAddButtons = async (cart) => {
    if (!cart) return;
    const buttons = qsa('[data-add-to-cart-card], [data-add-to-cart], [data-quick-view-atc], [data-wishlist-atc]');
    await Promise.all(buttons.map(async (btn) => {
      if (btn.hasAttribute('disabled') && btn.getAttribute('aria-disabled') === 'true' && btn.textContent.trim() === (window.GVFG?.soldOut || 'Sold out')) return;
      ensureAtcLabelDefault(btn);
      const variantId = btn.dataset.variantId || getCardAtcVariantId(btn) || btn.closest('form')?.querySelector('[data-variant-id]')?.value;
      if (!variantId) return;
      const handle = btn.closest('[data-product-handle]')?.dataset.productHandle || '';
      const maxInv = await resolveVariantInventoryMax(variantId, btn, handle);
      const remaining = getRemainingCartQty(cart, variantId, maxInv);
      const inCart = getCartQtyForVariant(cart, variantId);
      const qtyInput = btn.matches('[data-add-to-cart]')
        ? (btn.closest('form')?.querySelector('[data-product-qty]') || document.getElementById('Quantity'))
        : null;
      if (shouldMarkAtcAdded(btn, inCart, remaining, maxInv, qtyInput)) markAtcButtonAdded(btn);
      else if (btn.classList.contains('is-added')) resetAtcButton(btn);
    }));
  };

  const renderCartDrawerShipping = (cart) => {
    const wrap = document.getElementById('cartDrawerShipping');
    if (!wrap) return;
    const cfg = window.GVFG || {};
    if (!cfg.cartShowFreeShippingBar) {
      wrap.hidden = true;
      wrap.innerHTML = '';
      return;
    }
    wrap.hidden = false;
    const threshold = (cfg.cartFreeShippingThreshold || 2000) * 100;
    const total = cart.total_price || 0;
    const pct = Math.min(100, Math.round((total / threshold) * 100));
    if (total >= threshold) {
      wrap.innerHTML = `<div class="cart-drawer-shipping cart-drawer-shipping--complete"><p>${cfg.cartFreeShippingUnlocked || 'Free delivery unlocked!'}</p></div>`;
      return;
    }
    const remaining = threshold - total;
    const amountText = formatMoney(remaining);
    const msg = (cfg.cartFreeShippingRemaining || 'Only __AMOUNT__ away from Free Shipping').replace('__AMOUNT__', amountText);
    wrap.innerHTML = `
      <div class="cart-drawer-shipping">
        <div class="cart-drawer-shipping-bar" aria-hidden="true">
          <div class="cart-drawer-shipping-fill" style="width:${pct}%"><span>${pct}%</span></div>
        </div>
        <p class="cart-drawer-shipping-text">${msg}</p>
      </div>`;
  };

  const renderCartDrawerLine = (item) => {
    const hasCompare = item.original_price > item.final_price;
    const title = item.product_title || item.title;
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    const image = typeof item.image === 'string' ? item.image : item.featured_image?.url || '';
    return `
      <article class="cart-drawer-item" data-cart-item="${escapeHtml(item.key)}" data-variant-id="${item.variant_id}" data-product-handle="${escapeHtml(item.handle || '')}">
        <a href="${escapeHtml(item.url)}" class="cart-drawer-item-media">
          ${image
            ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(title)}" width="80" height="100" loading="lazy">`
            : '<span class="cart-drawer-item-placeholder" aria-hidden="true"></span>'}
        </a>
        <div class="cart-drawer-item-details">
          <a href="${escapeHtml(item.url)}" class="cart-drawer-item-title">${escapeHtml(title)}</a>
          ${variant ? `<p class="cart-drawer-item-variant">${escapeHtml(variant)}</p>` : ''}
          <div class="cart-drawer-item-prices">
            ${hasCompare ? `<span class="cart-drawer-item-compare">${formatMoney(item.original_price)}</span>` : ''}
            <span class="cart-drawer-item-price">${formatMoney(item.final_price)}</span>
          </div>
          <div class="cart-drawer-item-qty">
            <button type="button" class="cart-drawer-qty-btn" data-cart-qty-minus="${item.key}" aria-label="Decrease quantity">−</button>
            <span class="cart-drawer-qty-value" data-cart-qty-value="${item.key}">${item.quantity}</span>
            <button type="button" class="cart-drawer-qty-btn" data-cart-qty-plus="${item.key}" aria-label="Increase quantity">+</button>
          </div>
        </div>
        <button type="button" class="cart-drawer-item-remove" data-cart-remove="${item.key}" aria-label="${window.GVFG?.cartRemove || 'Remove'}">&times;</button>
      </article>`;
  };

  const refreshProductPageQtyState = (cart) => {
    const jsonEl = document.getElementById('ProductJSON');
    const form = document.querySelector('[data-product-form]');
    if (!jsonEl || !form) return;
    try {
      const product = JSON.parse(jsonEl.textContent);
      const variantInput = qs('[data-variant-id]', form);
      const variant = product.variants?.find(v => String(v.id) === String(variantInput?.value));
      if (!variant) return;
      const qtyInput = qs('[data-product-qty]', form) || document.getElementById('Quantity');
      const atcBtn = qs('[data-add-to-cart]', form);
      const qtyMinus = qs('[data-qty-minus]', form);
      const qtyPlus = qs('[data-qty-plus]', form);
      const maxInv = getVariantInventoryMax(variant, variant.id);
      const remaining = getRemainingCartQty(cart, variant.id, maxInv);
      const inCart = getCartQtyForVariant(cart, variant.id);
      if (qtyInput) {
        if (remaining === Infinity) {
          qtyInput.removeAttribute('max');
          qtyInput.min = 1;
        } else if (remaining === 0) {
          qtyInput.max = 0;
          qtyInput.value = '0';
          qtyInput.min = 0;
        } else {
          const maxSelectable = Math.max(1, remaining);
          qtyInput.max = maxSelectable;
          qtyInput.min = 1;
          const current = parseInt(qtyInput.value || '1', 10);
          if (current > maxSelectable) qtyInput.value = String(maxSelectable);
          if (current < 1) qtyInput.value = '1';
        }
      }
      if (qtyMinus) qtyMinus.disabled = remaining === 0 || parseInt(qtyInput?.value || '1', 10) <= 1;
      if (qtyPlus) qtyPlus.disabled = remaining !== Infinity && remaining <= 1;
      if (atcBtn) {
        ensureAtcLabelDefault(atcBtn);
        atcBtn.dataset.variantId = variant.id;
        const meta = getVariantInventoryMeta(variant.id);
        if (meta) {
          atcBtn.dataset.inventoryManaged = meta.inventory_management || '';
          if (meta.inventory_quantity != null) atcBtn.dataset.inventoryQuantity = String(meta.inventory_quantity);
        }
        if (remaining === 0 || shouldMarkAtcAdded(atcBtn, inCart, remaining, maxInv, qtyInput)) markAtcButtonAdded(atcBtn);
        else if (atcBtn.classList.contains('is-added')) resetAtcButton(atcBtn);
      }
    } catch (_) {}
  };

  const renderCartDrawer = (cart) => {
    const body = document.getElementById('cartDrawerBody');
    const footer = document.getElementById('cartDrawerFooter');
    const countEl = document.getElementById('cartDrawerCount');
    if (!body) return;

    updateCartBadges(cart.item_count);
    if (countEl) countEl.textContent = cart.item_count > 0 ? cartItemCountLabel(cart.item_count) : '';
    syncCartAddButtons(cart);
    refreshProductPageQtyState(cart);

    renderCartDrawerShipping(cart);

    if (!cart.item_count) {
      body.innerHTML = `
        <div class="cart-drawer-empty">
          <p>${window.GVFG?.cartEmpty || 'Your cart is empty'}</p>
          <a href="${window.GVFG?.routes?.allProducts || '/collections/all'}" class="btn btn-secondary cart-drawer-view-link">${window.GVFG?.cartContinueShopping || 'Continue shopping'}</a>
        </div>`;
      if (footer) {
        footer.hidden = true;
        footer.innerHTML = '';
      }
      return;
    }

    const items = Array.isArray(cart.items) ? cart.items : [];
    body.innerHTML = `<div class="cart-drawer-list">${items.map(renderCartDrawerLine).join('')}</div>`;
    if (!footer) return;
    footer.hidden = false;
    const phoneValue = cart.attributes?.Phone || getActiveCartPhoneInput()?.value || '';
    footer.innerHTML = `
      <div class="cart-drawer-totals">
        <div class="cart-drawer-total-row">
          <span>${window.GVFG?.cartSubtotal || 'Subtotal'}</span>
          <strong>${formatMoney(cart.items_subtotal_price)}</strong>
        </div>
        <div class="cart-drawer-total-row cart-drawer-total-row--main">
          <span>${window.GVFG?.cartTotal || 'Total'}</span>
          <strong>${formatMoney(cart.total_price)}</strong>
        </div>
      </div>
      ${renderCartPhoneField(phoneValue)}
      <div class="cart-drawer-actions">
        <button type="button" class="btn btn-primary cart-drawer-checkout" data-cart-drawer-checkout>${window.GVFG?.cartCheckout || 'Checkout'}</button>
        <a href="${window.GVFG?.routes?.cart || '/cart'}" class="btn btn-secondary cart-drawer-view-cart">${window.GVFG?.cartViewCart || 'View cart'}</a>
      </div>`;
  };

  const refreshCartDrawer = (options = {}) => {
    const drawer = document.getElementById('cartDrawer');
    if (!drawer || (!options.force && drawer.hidden)) return Promise.resolve();
    const body = document.getElementById('cartDrawerBody');
    const hasItems = !!body?.querySelector('.cart-drawer-item');
    if (body && !hasItems) {
      body.innerHTML = `<p class="cart-drawer-loading">${window.GVFG?.cartLoading || 'Loading cart…'}</p>`;
    }
    return fetchCart({ force: options.force === true })
      .then(renderCartDrawer)
      .catch(() => {
        if (body && !body.querySelector('.cart-drawer-item')) {
          body.innerHTML = `<p class="cart-drawer-empty">${window.GVFG?.cartEmpty || 'Your cart is empty'}</p>`;
        }
      });
  };

  const openCartDrawer = () => {
    window.__gvfgLoadWpm?.();
    const drawer = document.getElementById('cartDrawer');
    if (!drawer) return;
    closeWishlistDrawer();
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => {
      drawer.classList.add('open');
      refreshCartDrawer({ force: true });
    });
  };

  const closeCartDrawer = () => {
    const drawer = document.getElementById('cartDrawer');
    if (!drawer) return;
    drawer.classList.remove('open');
    document.body.style.overflow = '';
    setTimeout(() => {
      if (!drawer.classList.contains('open')) drawer.hidden = true;
    }, 300);
  };

  const addToCartAndOpenDrawer = (variantId, quantity = 1) =>
    addToCartRequest(variantId, quantity)
      .then(() => fetchCart())
      .then(cart => {
        syncCartAddButtons(cart);
        openCartDrawer();
        return cart;
      });

  const initSliders = (root = document) => {
    qsa('[data-product-slider]', root).forEach(slider => {
      if (slider.dataset.sliderReady) return;
      slider.dataset.sliderReady = '1';
      const scroll = qs('.product-scroll', slider);
      const prev = qs('.product-slider-btn.prev', slider);
      const next = qs('.product-slider-btn.next', slider);
      if (!scroll || !prev || !next) return;

      const itemSelector = slider.dataset.sliderItems || '.product-card';
      const getCards = () => qsa(itemSelector, scroll);
      let cardOffsets = null;
      const measureCards = () => {
        const cards = getCards();
        cardOffsets = cards.map(card => card.offsetLeft);
        return cards;
      };
      const getCurrentIndex = () => {
        if (!cardOffsets) measureCards();
        if (!cardOffsets?.length) return 0;
        const pos = scroll.scrollLeft;
        let idx = 0;
        let minDist = Infinity;
        cardOffsets.forEach((left, i) => {
          const dist = Math.abs(left - pos);
          if (dist < minDist) {
            minDist = dist;
            idx = i;
          }
        });
        return idx;
      };
      const goToIndex = (index) => {
        if (!cardOffsets) measureCards();
        const cards = getCards();
        if (!cards.length || !cardOffsets) return;
        const total = cards.length;
        const target = ((index % total) + total) % total;
        const left = cardOffsets[target];
        if (left == null) return;
        scroll.scrollTo({ left, behavior: 'smooth' });
      };

      prev.disabled = false;
      next.disabled = false;
      prev.addEventListener('click', () => goToIndex(getCurrentIndex() - 1));
      next.addEventListener('click', () => goToIndex(getCurrentIndex() + 1));
    });
  };

  const initAnnouncements = () => {
    const bar = document.getElementById('announcementBar');
    if (!bar) return;
    if (localStorage.getItem('gvfg_ann_dismissed')) {
      bar.remove();
      return;
    }

    const displayType = bar.dataset.displayType || 'rotate';
    const items = qsa('.announcement-item', bar);
    let idx = Math.max(0, items.findIndex(item => item.classList.contains('active')));
    let rotateTimer = null;

    const showAnnouncement = (nextIdx) => {
      if (!items.length) return;
      items[idx]?.classList.remove('active');
      idx = (nextIdx + items.length) % items.length;
      items[idx]?.classList.add('active');
    };

    const startAutoRotate = () => {
      if (rotateTimer?.stop) rotateTimer.stop();
      if (displayType !== 'rotate' || items.length < 2) return;
      const speed = (parseInt(bar.dataset.rotationSpeed, 10) || 4) * 1000;
      rotateTimer = createVisibilityInterval(() => showAnnouncement(idx + 1), speed);
    };

    if (items.length > 1 && (displayType === 'rotate' || displayType === 'static')) {
      qs('[data-announcement-prev]', bar)?.addEventListener('click', () => {
        showAnnouncement(idx - 1);
        startAutoRotate();
      });
      qs('[data-announcement-next]', bar)?.addEventListener('click', () => {
        showAnnouncement(idx + 1);
        startAutoRotate();
      });
    }

    startAutoRotate();

    qs('#announcementDismiss', bar)?.addEventListener('click', () => {
      if (rotateTimer?.stop) rotateTimer.stop();
      localStorage.setItem('gvfg_ann_dismissed', '1');
      bar.remove();
    });
  };

  const initQuickView = () => {
    const modal = document.getElementById('quickViewModal');
    if (!modal) return;
    const body = document.getElementById('quickViewBody');
    const close = () => { modal.hidden = true; document.body.style.overflow = ''; };
    qsa('[data-quick-view-close]', modal).forEach(el => el.addEventListener('click', close));

    document.addEventListener('click', async e => {
      const btn = e.target.closest('[data-quick-view]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      const handle = btn.dataset.quickView;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      modal.dataset.productHandle = handle || '';
      body.innerHTML = '<p class="quick-view-loading">Loading…</p>';
      try {
        const openerData = readInventoryFromElement(btn);
        if (openerData) cacheVariantInventory(openerData.variantId, openerData.meta);
        await fetchProductInventoryMap(handle);
        const res = await fetch(`/products/${handle}.js`);
        const p = await res.json();
        const preferredVariantId = btn.dataset.quickViewVariantId || openerData?.variantId;
        const variant = p.variants.find(v => String(v.id) === String(preferredVariantId))
          || p.variants.find(v => v.available)
          || p.variants[0];
        const invMeta = getVariantInventoryMeta(variant.id) || openerData?.meta;
        const invManaged = invMeta?.inventory_management || variant.inventory_management || '';
        const invQty = invMeta?.inventory_quantity ?? '';
        cacheVariantInventory(variant.id, {
          inventory_management: invManaged,
          inventory_quantity: invQty,
          available: variant.available
        });
        modal.dataset.variantId = String(variant.id);
        const available = isProductAvailable(p) && variant.available;
        const discount = variant.compare_at_price > variant.price
          ? Math.round((1 - variant.price / variant.compare_at_price) * 100) : 0;
        body.innerHTML = `
          <div class="quick-view-grid" data-product-handle="${p.handle}">
            <div class="quick-view-image">
              ${p.featured_image ? `<img src="${p.featured_image}" alt="${p.title.replace(/"/g, '')}" loading="lazy">` : ''}
            </div>
            <div class="quick-view-info">
              <h2 id="quickViewTitle">${p.title}</h2>
              <div class="product-prices">
                ${renderPriceContents(variant.price, variant.compare_at_price)}
              </div>
              ${available
                ? `<form action="/cart/add" method="post" class="quick-view-form" data-quick-view-form data-product-handle="${p.handle}">
                    <input type="hidden" name="id" value="${variant.id}">
                    <button type="submit" class="btn btn-add-to-cart" data-quick-view-atc data-variant-id="${variant.id}" data-inventory-managed="${invManaged}" data-inventory-quantity="${invQty}">${window.GVFG?.addToCart || 'Add to cart'}</button>
                  </form>`
                : '<button type="button" class="btn btn-sold-out" disabled aria-disabled="true">Sold out</button>'}
              <a href="/products/${p.handle}" class="quick-view-full-link">View full details</a>
            </div>
          </div>`;
        const qvForm = body.querySelector('[data-quick-view-form]');
        const atcBtn = qvForm?.querySelector('[data-quick-view-atc]');
        qvForm?.addEventListener('submit', ev => {
          if (!available) {
            ev.preventDefault();
            return;
          }
          ev.preventDefault();
          handleCardAddToCart(atcBtn);
        });
        fetchCart().then(cart => syncCartAddButtons(cart)).catch(() => {});
      } catch (_) {
        body.innerHTML = '<p class="quick-view-loading">Unable to load product.</p>';
      }
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !modal.hidden) close(); });
  };

  const initWishlist = () => {
    purgeUnavailableWishlist().then(() => {
      updateWishlistBadge();
      syncWishlistButtons();
    });

    document.addEventListener('click', async e => {
      const openBtn = e.target.closest('[data-wishlist-drawer-open]');
      if (openBtn) {
        e.preventDefault();
        openWishlistDrawer();
        return;
      }

      const closeBtn = e.target.closest('[data-wishlist-drawer-close]');
      if (closeBtn) {
        e.preventDefault();
        closeWishlistDrawer();
        return;
      }

      const removeBtn = e.target.closest('[data-wishlist-remove]');
      if (removeBtn) {
        e.preventDefault();
        toggleWishlist(removeBtn.dataset.wishlistRemove);
        return;
      }

      const btn = e.target.closest('.wishlist-add[data-product-handle]');
      if (!btn || btn.disabled || btn.dataset.productAvailable === 'false') return;
      e.preventDefault();
      e.stopPropagation();
      const handle = btn.dataset.productHandle;
      try {
        const res = await fetch(`/products/${handle}.js`);
        const product = res.ok ? await res.json() : null;
        if (!isProductAvailable(product)) return;
      } catch (_) {
        return;
      }
      toggleWishlist(handle);
    });

    document.addEventListener('keydown', e => {
      const drawer = document.getElementById('wishlistDrawer');
      if (e.key === 'Escape' && drawer && !drawer.hidden) closeWishlistDrawer();
    });

    initWishlistPage();
  };

  const HEART_SVG = '<svg class="icon-heart" viewBox="0 0 512 512" width="18" height="18" aria-hidden="true"><path d="M474.644,74.27C449.391,45.616,414.358,29.836,376,29.836c-53.948,0-88.103,32.22-107.255,59.25c-4.969,7.014-9.196,14.047-12.745,20.665c-3.549-6.618-7.775-13.651-12.745-20.665C266.086,35.795,230.454,0,172.639,0c-57.815,0-93.448,35.795-108.606,59.25C48.985,82.438,24.448,124.5,24.448,177.351c0,72.649,50.959,128.222,144.966,210.501c19.813,16.884,40.302,34.344,62.115,53.429l3.55,3.099c7.211,6.3,18.138,6.3,25.349,0l3.551-3.099c21.812-19.085,42.302-36.544,62.117-53.431C420.264,305.573,471.224,249.999,471.224,177.351C471.224,124.5,446.687,82.438,474.644,74.27z" fill="currentColor"/></svg>';
  const EYE_SVG = '<svg class="icon-eye" viewBox="0 0 512 512" width="18" height="18" aria-hidden="true"><path d="M508.745,246.041c-4.574-6.257-113.557-153.206-252.748-153.206S7.818,239.784,3.249,246.035c-4.332,5.936-4.332,13.987,0,19.923c4.569,6.257,113.557,153.206,252.748,153.206s248.174-146.95,252.748-153.201C513.083,260.028,513.083,251.971,508.745,246.041z M255.997,385.406c-102.529,0-191.33-97.533-217.617-129.418c26.253-31.913,114.868-129.395,217.617-129.395c102.524,0,191.319,97.516,217.617,129.418C447.361,287.923,358.746,385.406,255.997,385.406z" fill="currentColor"/><path d="M255.997,154.725c-55.842,0-101.275,45.433-101.275,101.275s45.433,101.275,101.275,101.275s101.275-45.433,101.275-101.275S311.839,154.725,255.997,154.725z M255.997,323.516c-37.23,0-67.516-30.287-67.516-67.516s30.287-67.516,67.516-67.516s67.516,30.287,67.516,67.516S293.227,323.516,255.997,323.516z" fill="currentColor"/></svg>';

  const renderProductCard = (p) => {
    const variant = p.variants?.find(v => v.available) || p.variants?.[0] || p;
    const price = p.price ?? variant.price;
    const compare = p.compare_at_price ?? variant.compare_at_price;
    const discount = compare > price ? Math.round((1 - price / compare) * 100) : 0;
    const cardCfg = window.GVFG?.card || { showSize: true, showCondition: true, enableAtc: true, showSoldOutOverlay: true, secondImageHover: true };
    const img = sizedCdnImage(p.featured_image || p.images?.[0], 280);
    const img2 = sizedCdnImage(p.images?.[1], 280);
    const hoverSecond = cardCfg.secondImageHover !== false;
    const handle = p.handle;
    let size = typeof resolveProductSize === 'function' ? resolveProductSize(p) : '';
    if (!size) size = variant.option1 || p.options?.[0]?.values?.[0] || '';
    if (size === 'Default Title') size = '';
    const conditionLabel = typeof resolveProductCondition === 'function' ? resolveProductCondition(p) : 'Good';
    const conditionClass = typeof conditionClassFromLabel === 'function' ? conditionClassFromLabel(conditionLabel) : 'good';
    const showConditionBadge = cardCfg.showCondition !== false;
    const conditionBadge = showConditionBadge
      ? `<span class="condition-badge ${conditionClass}">${conditionLabel}</span>`
      : '';
    const safeTitle = (p.title || '').replace(/"/g, '&quot;');
    const safeSku = String(variant.sku || '').replace(/"/g, '&quot;');
    const safeSize = String(size || '').replace(/"/g, '&quot;');
    const safeCondition = String(conditionLabel || 'Good').replace(/"/g, '&quot;');
    const available = p.available !== false && (variant.available !== false);
    const badge = !available
      ? `<div class="product-badges product-badges--right"><span class="badge sold-out-badge">Sold out</span></div>${cardCfg.showSoldOutOverlay ? '<div class="sold-out-overlay" aria-hidden="true"><span class="sold-out-label">Sold out</span></div>' : ''}`
      : discount > 0
        ? `<div class="product-badges product-badges--right"><span class="badge sale-badge">-${discount}%</span></div>`
        : '';
    const sizeBlock = cardCfg.showSize && size && available
      ? `<div class="card-bottom-dock-size"><div class="wrapper-item-size card-product__group text-center"><ul class="sizes-list"><li class="size-item"><a href="${productPath(handle)}" title="${size}">${size}</a></li></ul></div></div>`
      : '';
    const atcBlock = cardCfg.enableAtc
      ? `<div class="card-action"><button type="button" class="btn-card-atc" data-add-to-cart-card data-variant-id="${variant.id}" data-inventory-managed="${variant.inventory_management || ''}" data-inventory-quantity="${variant.inventory_quantity ?? ''}"${available ? '' : ' disabled'}>${available ? (window.GVFG?.addToCart || 'Add to cart') : 'Sold out'}</button></div>`
      : '';
    const wishlistBlock = available
      ? `<div class="card-product__group-item card-wishlist">
          <button type="button" class="wishlist-icon wishlist-add${isWishlisted(handle) ? ' active' : ''}" data-product-handle="${handle}" data-product-available="true" aria-label="Wishlist">${HEART_SVG}</button>
        </div>`
      : '';
    return `
      <article class="product-card${available ? '' : ' is-sold-out'}" data-product-handle="${handle}" data-product-title="${safeTitle}" data-product-sku="${safeSku}" data-product-size="${safeSize}" data-product-condition="${safeCondition}">
        <div class="product-image">
          <a href="${productPath(handle)}" class="product-card-link">
            ${conditionBadge}
            ${badge}
            ${img
              ? `<div class="card-media${hoverSecond && img2 ? ' media--hover-effect' : ''}">
                  <img src="${img}" alt="${p.title.replace(/"/g, '')}" loading="lazy" decoding="async" width="240" height="320" class="product-img product-img--primary${available ? '' : ' is-dimmed'}">
                  ${hoverSecond && img2 ? `<img src="${img2}" alt="${p.title.replace(/"/g, '')}" loading="lazy" decoding="async" width="240" height="320" class="product-img product-img--secondary${available ? '' : ' is-dimmed'}">` : ''}
                </div>`
              : '<div class="product-placeholder"></div>'}
          </a>
          <div class="card-product__group group-right">
            ${wishlistBlock}
            <div class="card-product__group-item card-quickview card-quickviewIcon">
              <button type="button" class="quickview-icon quick-view-btn" data-quick-view="${handle}" data-quick-view-variant-id="${variant.id}" data-inventory-managed="${variant.inventory_management || ''}" data-inventory-quantity="${variant.inventory_quantity ?? ''}" aria-label="Quick view">${EYE_SVG}</button>
            </div>
          </div>
          ${sizeBlock}
          ${atcBlock}
        </div>
        <div class="product-info">
          <h3><a href="${productPath(handle)}">${p.title}</a></h3>
          ${safeSku ? `<p class="product-card-sku">SKU: ${safeSku}</p>` : ''}
          <div class="product-prices">
            ${renderPriceContents(price, compare)}
          </div>
        </div>
      </article>`;
  };

  const initWishlistPage = () => {
    const grid = document.getElementById('wishlist-grid');
    const empty = document.getElementById('wishlist-empty');
    if (!grid) return;
    const handles = getWishlist();
    if (!handles.length) {
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    Promise.all(handles.map(h => fetch(`/products/${h}.js`).then(r => r.ok ? r.json() : null).catch(() => null)))
      .then(products => {
        const valid = products.filter(p => p && isProductAvailable(p));
        if (valid.length !== handles.length) {
          setWishlist(valid.map(p => p.handle));
          updateWishlistBadge();
        }
        if (!valid.length) { if (empty) empty.hidden = false; return; }
        grid.innerHTML = valid.map(renderProductCard).join('');
        initSliders(grid);
        fetchCart().then(cart => syncCartAddButtons(cart)).catch(() => {});
      });
  };

  const initVariantPicker = () => {
    const jsonEl = document.getElementById('ProductJSON');
    const form = document.querySelector('[data-product-form]');
    if (!jsonEl || !form) return;
    const product = JSON.parse(jsonEl.textContent);
    const variantInput = qs('[data-variant-id]', form);
    const priceEl = qs('[data-product-price]');
    const compareEl = qs('[data-product-compare]');
    const discountEl = qs('[data-product-discount]');
    const availableBlock = qs('[data-product-actions-available]', form);
    const soldOutBtn = qs('[data-product-sold-out-btn]', form);
    const optionSelects = qsa('[data-product-option]', form);

    const findVariant = () => {
      const options = optionSelects.map(s => s.value);
      return product.variants.find(v =>
        v.options.every((opt, i) => !optionSelects.length || opt === options[i])
      ) || product.variants[0];
    };

    const setProductActions = (inStock) => {
      if (availableBlock) {
        availableBlock.hidden = !inStock;
        availableBlock.style.display = inStock ? '' : 'none';
      }
      if (soldOutBtn) {
        soldOutBtn.hidden = inStock;
        soldOutBtn.style.display = inStock ? 'none' : '';
      }
    };

    const qtyInput = qs('[data-product-qty]', form) || document.getElementById('Quantity');
    const atcBtn = qs('[data-add-to-cart]', form);
    const qtyMinus = qs('[data-qty-minus]', form);
    const qtyPlus = qs('[data-qty-plus]', form);

    const updateVariant = () => {
      const variant = findVariant();
      if (!variant) return;
      variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      const onSale = Number(variant.compare_at_price) > Number(variant.price);
      if (compareEl) {
        compareEl.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
        compareEl.hidden = !onSale;
      }
      if (discountEl) {
        const discount = onSale ? Math.round((1 - Number(variant.price) / Number(variant.compare_at_price)) * 100) : 0;
        discountEl.textContent = onSale ? `-${discount}%` : '';
        discountEl.hidden = !onSale || window.GVFG?.card?.showInlineDiscount === false;
      }
      setProductActions(variant.available);
      if (variant.featured_image) {
        const img = variant.featured_image.src || variant.featured_image;
        if (img) {
          if (typeof window.gvfgGalleryGoTo === 'function') window.gvfgGalleryGoTo(img);
          else {
            const mainImg = document.getElementById('ProductImage');
            if (mainImg) mainImg.src = img.includes('http') ? img : img;
          }
        }
      }
      fetchCart()
        .then(cart => {
          refreshProductPageQtyState(cart);
          syncCartAddButtons(cart);
        })
        .catch(() => {});
    };

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', () => {
        qtyInput.value = String(Math.max(1, parseInt(qtyInput.value || '1', 10) - 1));
      });
    }
    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', () => {
        const max = parseInt(qtyInput.max || '1', 10);
        qtyInput.value = String(Math.min(max, parseInt(qtyInput.value || '1', 10) + 1));
      });
    }

    optionSelects.forEach(s => s.addEventListener('change', updateVariant));
    updateVariant();
  };

  const closeCollectionSidebar = () => {
    document.getElementById('collection-sidebar')?.classList.remove('open');
    document.getElementById('sidebar-overlay')?.classList.remove('active');
    document.body.style.overflow = '';
  };

  const GVFG_SIZE_ALIASES = {
    XXS: ['xxs', 'extraextrasmall', 'extraextrasmall'],
    XS: ['xs', 'extrasmall'],
    S: ['s', 'small'],
    M: ['m', 'medium', 'med'],
    L: ['l', 'large', 'llarge'],
    XL: ['xl', 'extralarge'],
    XXL: ['xxl', '2xl', 'xxlarge']
  };

  const normalizeSizeToken = (value) => String(value || '').toLowerCase().replace(/[\s\-_./]/g, '');

  const isNumericSizeNoise = (value) => /^\d+$/.test(String(value || '').trim());

  const mapProductSizeToFilter = (rawSize) => {
    const raw = String(rawSize || '').trim();
    if (!raw || isNumericSizeNoise(raw)) return '';
    const token = normalizeSizeToken(raw);
    for (const [filterSize, aliases] of Object.entries(GVFG_SIZE_ALIASES)) {
      if (aliases.some(alias => token === alias || token.includes(alias) || alias.includes(token))) {
        return filterSize;
      }
    }
    return raw;
  };

  const GVFG_CONDITION_LABELS = ['New', 'Premium', 'Excellent', 'Good'];

  const normalizeConditionValue = (value) => {
    let raw = String(value || '').trim();
    if (raw.includes('">')) raw = raw.split('">').pop() || raw;
    else if (raw.includes('style=')) raw = raw.split('>').pop() || raw;
    raw = raw.trim();
    const token = raw.toLowerCase().replace(/\s+/g, ' ');
    if (!token) return 'Good';
    if (token.includes('excellent') || token.includes('exellent')) return 'Excellent';
    if (token.includes('premium plus') || token.includes('premium+')) return 'Premium';
    if (token.includes('premium') || token.includes('like-new') || token.includes('like new') || token.includes('almost new')) return 'Premium';
    if (token === 'good' || token.includes('wearable') || token.includes('clean &')) return 'Good';
    if (token === 'new' || token.startsWith('new ') || token.includes('brand-new') || token.includes('brand new') || token.includes('unused') || token.includes('never worn')) return 'New';
    if (GVFG_CONDITION_LABELS.includes(raw)) return raw;
    if (token.includes('new')) return 'New';
    return 'Good';
  };

  const parseRawConditionFromHtml = (html) => {
    const source = String(html || '');
    const match = source.match(/Condition\s*:<\/strong>\s*([^<]+)/i)
      || source.match(/Condition\s*:\s*([^<\n]+)/i);
    return match ? match[1].trim() : '';
  };

  const parseConditionFromProductHtml = (html) => normalizeConditionValue(parseRawConditionFromHtml(html));

  const resolveProductCondition = (product) => {
    if (!product) return 'Good';
    const html = product.body_html || product.description || '';
    let raw = parseRawConditionFromHtml(html);
    if (!raw && Array.isArray(product.tags)) {
      for (const tag of product.tags) {
        const token = String(tag || '').toLowerCase();
        if (token === 'new' || token === 'premium' || token === 'excellent' || token === 'good') {
          raw = tag;
          break;
        }
      }
    }
    if (!raw) {
      const vendor = String(product.vendor || '').trim();
      if (vendor && vendor !== 'GVFG') raw = vendor.replace(/^Condition:\s*/i, '').trim();
    }
    return normalizeConditionValue(raw);
  };

  const parseRawSizeFromHtml = (html) => {
    const source = String(html || '');
    const match = source.match(/Size\s*:<\/strong>\s*([^<]+)/i)
      || source.match(/•\s*Size\s*:\s*([^<]+)/i)
      || source.match(/Size\s*:\s*([^<\n]+)/i);
    return match ? match[1].trim() : '';
  };

  const resolveProductSize = (product) => {
    if (!product) return '';
    const html = product.body_html || product.description || '';
    let raw = parseRawSizeFromHtml(html);
    if (!raw) {
      const variant = product.variants?.[0];
      raw = variant?.option1 || product.options?.[0]?.values?.[0] || '';
      if (raw === 'Default Title') raw = '';
    }
    return String(raw || '').trim();
  };

  const getCollectionHandle = () => {
    const match = (window.location.pathname || '').match(/\/collections\/([^/?#]+)/);
    return match ? match[1] : '';
  };

  let gvfgCollectionProductsCache = null;
  let gvfgCollectionProductsHandle = '';
  let gvfgOriginalGridHtml = null;
  let gvfgCustomFilterRequest = 0;

  const fetchAllCollectionProducts = async (handle) => {
    if (!handle) return [];
    if (gvfgCollectionProductsHandle && gvfgCollectionProductsHandle !== handle) {
      gvfgCollectionProductsCache = null;
      gvfgOriginalGridHtml = null;
    }
    if (gvfgCollectionProductsCache?.handle === handle) return gvfgCollectionProductsCache.products;

    const products = [];
    let page = 1;
    while (page <= 20) {
      const res = await fetch(`/collections/${handle}/products.json?limit=250&page=${page}`);
      if (!res.ok) break;
      const data = await res.json();
      const batch = data.products || [];
      if (!batch.length) break;
      products.push(...batch);
      if (batch.length < 250) break;
      page += 1;
    }

    gvfgCollectionProductsCache = { handle, products };
    gvfgCollectionProductsHandle = handle;
    return products;
  };

  const buildConditionCountsFromProducts = (products, sizes = [], conditions = []) => {
    const counts = { New: 0, Premium: 0, Excellent: 0, Good: 0 };
    const hasCustomFilter = sizes.length > 0 || conditions.length > 0;
    (products || []).forEach(product => {
      const label = resolveProductCondition(product);
      if (!GVFG_CONDITION_LABELS.includes(label)) return;
      if (!hasCustomFilter) {
        counts[label] += 1;
        return;
      }
      const rawSize = resolveProductSize(product);
      const mappedSize = mapProductSizeToFilter(rawSize);
      const sizeMatch = !sizes.length || sizes.some(size => size === mappedSize || size === rawSize);
      if (!sizeMatch) return;
      const relaxedConditions = conditions.filter(Boolean);
      const matchesCurrent = !relaxedConditions.length || relaxedConditions.includes(label);
      if (matchesCurrent) counts[label] += 1;
    });
    return counts;
  };

  const renderConditionFacetCounts = (counts, root = document) => {
    qsa('[data-custom-filter-block="condition"] .facet-item', root).forEach(item => { item.hidden = false; });
    qsa('[data-facet-count-for]', root).forEach(el => {
      const key = el.dataset.facetCountFor;
      if (!GVFG_CONDITION_LABELS.includes(key)) return;
      const count = counts[key] || 0;
      el.textContent = count ? `(${count})` : '';
    });
  };

  const productJsonMatchesCustomFilters = (product, sizes, conditions) => {
    const rawSize = resolveProductSize(product);
    const mappedSize = mapProductSizeToFilter(rawSize);
    const condition = resolveProductCondition(product);
    const sizeMatch = !sizes.length || sizes.some(size => size === mappedSize || size === rawSize);
    const conditionMatch = !conditions.length || conditions.includes(condition);
    return sizeMatch && conditionMatch;
  };

  const conditionClassFromLabel = (label) => {
    const token = String(label || '').toLowerCase();
    if (token === 'excellent') return 'excellent';
    if (token === 'premium') return 'premium';
    if (token === 'new') return 'new';
    return 'good';
  };

  const initCollectionConditionCounts = () => {
    const collectionMain = document.getElementById('collection-main');
    const grid = document.getElementById('collection-product-grid');
    if (!collectionMain || !grid) return;

    const handle = getCollectionHandle();
    if (!handle) return;

    const { sizes, conditions } = getCustomFilterSelections(document);
    fetchAllCollectionProducts(handle)
      .then(products => {
        const fullCounts = buildConditionCountsFromProducts(products);
        collectionMain.dataset.gvfgFullConditionCounts = JSON.stringify(fullCounts);
        const activeCounts = buildConditionCountsFromProducts(products, sizes, conditions);
        renderConditionFacetCounts(activeCounts, document);
      })
      .catch(() => {});
  };

  const getCustomFilterSelections = (root = document) => {
    const sizes = qsa('[data-custom-filter-input][data-filter-type="size"]:checked', root).map(input => input.value);
    const conditions = qsa('[data-custom-filter-input][data-filter-type="condition"]:checked', root).map(input => input.value);
    return { sizes, conditions };
  };

  const appendCustomFilterParams = (params, root = document) => {
    params.delete('gvfg_size');
    params.delete('gvfg_condition');
    const { sizes, conditions } = getCustomFilterSelections(root);
    sizes.forEach(size => params.append('gvfg_size', size));
    conditions.forEach(condition => params.append('gvfg_condition', condition));
    return params;
  };

  const restoreCustomFiltersFromParams = (params = new URLSearchParams(window.location.search), root = document) => {
    const sizes = params.getAll('gvfg_size');
    const conditions = params.getAll('gvfg_condition');
    qsa('[data-custom-filter-input][data-filter-type="size"]', root).forEach(input => {
      input.checked = sizes.includes(input.value);
    });
    qsa('[data-custom-filter-input][data-filter-type="condition"]', root).forEach(input => {
      input.checked = conditions.includes(input.value);
    });
  };

  const productMatchesCustomFilters = (card, sizes, conditions) => {
    const rawSize = String(card.dataset.productSize || '').trim();
    const mappedSize = mapProductSizeToFilter(rawSize);
    const condition = normalizeConditionValue(card.dataset.productCondition || 'Good');
    const sizeMatch = !sizes.length || sizes.some(size => size === mappedSize || size === rawSize);
    const conditionMatch = !conditions.length || conditions.includes(condition);
    return sizeMatch && conditionMatch;
  };

  const updateCustomFacetCounts = (root = document) => {
    const cards = qsa('#collection-product-grid .product-card', root);
    const sizeCounts = {};
    const conditionCounts = {};
    const extraSizes = new Set();
    const { sizes, conditions } = getCustomFilterSelections(root);
    const hasCustomFilter = sizes.length > 0 || conditions.length > 0;
    const collectionMain = qs('#collection-main', root) || document.getElementById('collection-main');

    cards.forEach(card => {
      const rawSize = String(card.dataset.productSize || '').trim();
      const mappedSize = mapProductSizeToFilter(rawSize);
      const condition = normalizeConditionValue(card.dataset.productCondition || 'Good');
      const show = productMatchesCustomFilters(card, sizes, conditions);

      if (mappedSize && (!hasCustomFilter || show)) {
        if (GVFG_SIZE_ALIASES[mappedSize]) {
          sizeCounts[mappedSize] = (sizeCounts[mappedSize] || 0) + 1;
        } else {
          extraSizes.add(mappedSize);
          sizeCounts[mappedSize] = (sizeCounts[mappedSize] || 0) + 1;
        }
      }
      if (!hasCustomFilter || show) {
        conditionCounts[condition] = (conditionCounts[condition] || 0) + 1;
      }
    });

    if (GVFG_CONDITION_LABELS.some(label => qsa(`[data-facet-count-for="${label}"]`, root).length)) {
      let conditionFacetCounts = null;
      if (!hasCustomFilter && collectionMain?.dataset.gvfgFullConditionCounts) {
        try {
          conditionFacetCounts = JSON.parse(collectionMain.dataset.gvfgFullConditionCounts);
        } catch (_) {
          conditionFacetCounts = null;
        }
      }
      if (!conditionFacetCounts) conditionFacetCounts = conditionCounts;
      renderConditionFacetCounts(conditionFacetCounts, root);
    }

    qsa('[data-facet-count-for]', root).forEach(el => {
      const key = el.dataset.facetCountFor;
      if (GVFG_CONDITION_LABELS.includes(key)) return;
      const count = sizeCounts[key] || 0;
      el.textContent = count ? `(${count})` : '';
    });

    const extraList = qs('[data-custom-size-extra]', root);
    if (!extraList) return;
    extraList.innerHTML = '';
    const sortedExtras = [...extraSizes]
      .filter(size => !isNumericSizeNoise(size) && !GVFG_SIZE_ALIASES[size])
      .sort((a, b) => a.localeCompare(b));
    if (!sortedExtras.length) {
      extraList.hidden = true;
      return;
    }
    extraList.hidden = false;
    const activeSizes = new URLSearchParams(window.location.search).getAll('gvfg_size');
    extraList.innerHTML = sortedExtras.map(size => `
      <li class="facet-item facet-item--pill">
        <label class="facet-pill mts-size-pill">
          <input
            type="checkbox"
            name="gvfg_size"
            value="${size.replace(/"/g, '&quot;')}"
            data-custom-filter-input
            data-filter-type="size"
            ${activeSizes.includes(size) ? 'checked' : ''}
          >
          <span>${size}</span>
        </label>
      </li>`).join('');
  };

  const updateCustomRefinedTags = (root = document) => {
    const refinedBlock = qs('#refined-block', root);
    const refinedList = qs('#refined-block .refined-list', root);
    if (!refinedBlock || !refinedList) return;

    qsa('[data-custom-refined-tag]', refinedList).forEach(el => el.remove());
    const { sizes, conditions } = getCustomFilterSelections(root);
    [...sizes, ...conditions].forEach(value => {
      const li = document.createElement('li');
      li.innerHTML = `<button type="button" class="refined-tag" data-custom-refined-tag data-custom-refined-value="${value.replace(/"/g, '&quot;')}">${value} ×</button>`;
      refinedList.appendChild(li);
    });

    const nativeTags = qsa('.refined-list .refined-tag:not([data-custom-refined-tag])', root).length;
    refinedBlock.hidden = nativeTags === 0 && sizes.length === 0 && conditions.length === 0;
  };

  const updateFilterEmptyState = (root, visible, sizes, conditions) => {
    const empty = qs('#collection-filter-empty', root);
    const grid = qs('#collection-product-grid', root);
    const pagination = qs('.pagination-wrapper', root);
    const hasCustomFilter = sizes.length > 0 || conditions.length > 0;
    const showEmpty = hasCustomFilter && visible === 0 && grid;

    if (empty) empty.hidden = !showEmpty;
    if (grid) grid.hidden = !!showEmpty;
    if (pagination) pagination.hidden = !!showEmpty || (hasCustomFilter && visible > 0);
  };

  const refreshFilteredCollectionCards = (grid, root = document) => {
    initSliders(grid);
    syncWishlistButtons();
    seedVariantInventoryCache(root);
    fetchCart().then(cart => syncCartAddButtons(cart)).catch(() => {});
  };

  const applyCustomCollectionFilters = async (root = document) => {
    const grid = qs('#collection-product-grid', root);
    if (!grid) return;

    const { sizes, conditions } = getCustomFilterSelections(root);
    const hasCustomFilter = sizes.length > 0 || conditions.length > 0;
    const pagination = qs('.pagination-wrapper', root);
    const countEl = qs('[data-results-count]', root);

    if (!hasCustomFilter) {
      if (grid.dataset.gvfgFiltered === '1' && gvfgOriginalGridHtml) {
        grid.innerHTML = gvfgOriginalGridHtml;
        grid.dataset.gvfgFiltered = '0';
        gvfgOriginalGridHtml = null;
        if (pagination) pagination.hidden = false;
        refreshFilteredCollectionCards(grid, root);
      }

      const cards = qsa('.product-card', grid);
      let visible = 0;
      cards.forEach(card => {
        card.hidden = false;
        visible += 1;
      });

      if (countEl) {
        const total = Number(countEl.dataset.totalCount || cards.length);
        countEl.textContent = String(total);
      }

      updateFilterEmptyState(root, visible, sizes, conditions);
      updateCustomFacetCounts(root);
      updateCustomRefinedTags(root);
      return;
    }

    const handle = getCollectionHandle();
    if (!handle) return;

    if (!gvfgOriginalGridHtml && grid.dataset.gvfgFiltered !== '1') {
      gvfgOriginalGridHtml = grid.innerHTML;
    }

    const requestId = ++gvfgCustomFilterRequest;
    grid.classList.add('is-filtering');

    try {
      const products = await fetchAllCollectionProducts(handle);
      if (requestId !== gvfgCustomFilterRequest) return;

      const filtered = products.filter(product => productJsonMatchesCustomFilters(product, sizes, conditions));
      grid.innerHTML = filtered.map(renderProductCard).join('');
      grid.dataset.gvfgFiltered = '1';
      if (pagination) pagination.hidden = true;
      refreshFilteredCollectionCards(grid, root);

      if (countEl) countEl.textContent = String(filtered.length);

      updateFilterEmptyState(root, filtered.length, sizes, conditions);
      updateCustomFacetCounts(root);
      updateCustomRefinedTags(root);
      initCollectionConditionCounts();
    } catch (_) {
      if (requestId !== gvfgCustomFilterRequest) return;
      const cards = qsa('.product-card', grid);
      let visible = 0;
      cards.forEach(card => {
        const show = productMatchesCustomFilters(card, sizes, conditions);
        card.hidden = !show;
        if (show) visible += 1;
      });
      if (countEl) countEl.textContent = String(visible);
      updateFilterEmptyState(root, visible, sizes, conditions);
      updateCustomFacetCounts(root);
      updateCustomRefinedTags(root);
    } finally {
      if (requestId === gvfgCustomFilterRequest) grid.classList.remove('is-filtering');
    }
  };

  const syncCustomFiltersToUrl = (params) => {
    appendCustomFilterParams(params);
    const url = new URL(window.location.pathname, window.location.origin);
    params.forEach((value, key) => {
      if (key !== 'section_id' && value !== '') url.searchParams.append(key, value);
    });
    window.history.replaceState({ collectionFilters: true }, '', url.toString());
  };

  const buildCollectionParams = (sourceForm) => {
    const params = new URLSearchParams();
    const filterForm = document.getElementById('CollectionFiltersForm');
    if (sourceForm?.id === 'CollectionFiltersForm') {
      new FormData(sourceForm).forEach((v, k) => { if (v !== '') params.append(k, v); });
    } else if (filterForm) {
      new FormData(filterForm).forEach((v, k) => {
        if (k !== 'sort_by' && v !== '') params.append(k, v);
      });
    } else {
      new URLSearchParams(window.location.search).forEach((v, k) => {
        if (k.startsWith('filter.') || k === 'sort_by' || k === 'page' || k === 'gvfg_size' || k === 'gvfg_condition') {
          params.append(k, v);
        }
      });
    }
    const sortSelect = document.querySelector('[data-sort-by]');
    if (sortSelect?.value) params.set('sort_by', sortSelect.value);
    return appendCustomFilterParams(params);
  };

  const applyCollectionView = (doc, activeCols) => {
    const collectionMain = document.getElementById('collection-main');
    const collectionSidebar = document.getElementById('collection-sidebar');
    const newMain = doc.getElementById('collection-main');
    const newSidebar = doc.getElementById('collection-sidebar');
    if (newMain && collectionMain) collectionMain.innerHTML = newMain.innerHTML;
    if (newSidebar && collectionSidebar) collectionSidebar.innerHTML = newSidebar.innerHTML;

    gvfgOriginalGridHtml = null;
    const nextHandle = getCollectionHandle();
    if (nextHandle && gvfgCollectionProductsHandle && gvfgCollectionProductsHandle !== nextHandle) {
      gvfgCollectionProductsCache = null;
    }
    const grid = document.getElementById('collection-product-grid');
    const defaultCols = grid?.dataset.defaultCols || '4';
    const cols = activeCols || defaultCols;
    if (grid) grid.className = `collection-grid column-${cols}`;
    qsa('[data-view-as] [data-cols]').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.cols === String(cols));
    });

    initCollectionPage();
    seedVariantInventoryCache(document);
    initPriceRangeFilters(document);
    initSliders(collectionMain || document);
    syncWishlistButtons();
    restoreCustomFiltersFromParams(new URLSearchParams(window.location.search), document);
    initCollectionConditionCounts();
    applyCustomCollectionFilters(document);
  };

  let collectionFilterRequest = 0;
  const fetchCollectionView = async (params, pushState = true) => {
    const collectionMain = document.getElementById('collection-main');
    if (!collectionMain) return;

    const viewUrl = new URL(window.location.pathname, window.location.origin);
    const cleanParams = new URLSearchParams();
    params.forEach((v, k) => {
      if (k !== 'section_id' && v !== '') cleanParams.append(k, v);
    });
    cleanParams.forEach((v, k) => viewUrl.searchParams.append(k, v));

    const fetchUrl = new URL(viewUrl);
    fetchUrl.searchParams.set('section_id', 'main-collection');

    const activeCols = qs('[data-view-as] [data-cols].active')?.dataset.cols;
    const requestId = ++collectionFilterRequest;
    collectionMain.classList.add('is-filtering');
    document.getElementById('CollectionFiltersForm')?.classList.add('is-submitting');

    try {
      const res = await fetch(fetchUrl.toString());
      if (!res.ok) throw new Error('Collection fetch failed');
      const html = await res.text();
      if (requestId !== collectionFilterRequest) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      applyCollectionView(doc, activeCols);
      if (pushState) window.history.pushState({ collectionFilters: true }, '', viewUrl.toString());
      closeCollectionSidebar();
    } catch (_) {
      window.location.href = viewUrl.toString();
    } finally {
      if (requestId === collectionFilterRequest) {
        collectionMain.classList.remove('is-filtering');
        document.getElementById('CollectionFiltersForm')?.classList.remove('is-submitting');
      }
    }
  };

  const initCollectionFilters = () => {
    if (!document.getElementById('collection-main')) return;

    document.addEventListener('submit', e => {
      const filterForm = e.target.closest('#CollectionFiltersForm');
      if (filterForm) {
        e.preventDefault();
        fetchCollectionView(buildCollectionParams(filterForm));
        return;
      }
      const sortForm = e.target.closest('.toolbar-sort-form');
      if (sortForm) {
        e.preventDefault();
        fetchCollectionView(buildCollectionParams(sortForm));
      }
    });

    document.addEventListener('change', e => {
      const input = e.target;
      if (input.matches('[data-custom-filter-input]')) {
        const params = buildCollectionParams();
        syncCustomFiltersToUrl(params);
        applyCustomCollectionFilters();
        return;
      }
      if (input.matches('[data-filter-input]')) {
        const form = input.closest('#CollectionFiltersForm');
        if (form) fetchCollectionView(buildCollectionParams(form));
        return;
      }
      if (input.matches('[data-sort-by]')) {
        fetchCollectionView(buildCollectionParams());
      }
    });

    document.addEventListener('click', e => {
      const customRefined = e.target.closest('[data-custom-refined-tag]');
      if (customRefined) {
        e.preventDefault();
        const value = customRefined.dataset.customRefinedValue;
        qsa('[data-custom-filter-input]').forEach(input => {
          if (input.checked && input.value === value) input.checked = false;
        });
        const params = buildCollectionParams();
        syncCustomFiltersToUrl(params);
        applyCustomCollectionFilters();
        return;
      }

      const clearAll = e.target.closest('#collection-sidebar .facets-clear-all');
      if (clearAll) {
        e.preventDefault();
        qsa('[data-custom-filter-input]').forEach(input => { input.checked = false; });
        const url = new URL(clearAll.href || window.location.pathname, window.location.origin);
        fetchCollectionView(new URLSearchParams(url.search));
        return;
      }

      const facetLink = e.target.closest('#collection-sidebar .refined-tag');
      if (facetLink?.href) {
        e.preventDefault();
        const url = new URL(facetLink.href, window.location.origin);
        fetchCollectionView(new URLSearchParams(url.search));
        return;
      }
      const pageLink = e.target.closest('#collection-main a.pagination-item.link');
      if (!pageLink?.href) return;
      const url = new URL(pageLink.href, window.location.origin);
      if (url.pathname !== window.location.pathname) return;
      e.preventDefault();
      fetchCollectionView(new URLSearchParams(url.search));
    });

    window.addEventListener('popstate', () => {
      fetchCollectionView(new URLSearchParams(window.location.search), false);
    });

    restoreCustomFiltersFromParams();
    applyCustomCollectionFilters();
  };

  const initPriceRangeFilters = (root = document) => {
    qsa('[data-price-range]', root).forEach(wrap => {
      if (wrap.dataset.priceReady) return;
      wrap.dataset.priceReady = '1';

      const max = Number(wrap.dataset.priceMax) || 1000;
      const minRange = qs('[data-price-range-min]', wrap);
      const maxRange = qs('[data-price-range-max]', wrap);
      const minInput = qs('[data-price-input-min]', wrap);
      const maxInput = qs('[data-price-input-max]', wrap);
      const fill = qs('[data-price-range-fill]', wrap);
      if (!minRange || !maxRange || !minInput || !maxInput) return;

      const updateFill = (lo, hi) => {
        if (!fill || max <= 0) return;
        fill.style.left = `${(lo / max) * 100}%`;
        fill.style.right = `${100 - (hi / max) * 100}%`;
      };

      const syncValues = (source = 'input') => {
        let lo = Math.max(0, Math.min(Number(minInput.value || 0), max));
        let hi = Math.max(0, Math.min(Number(maxInput.value || max), max));
        if (lo > hi) {
          if (source === 'min') hi = lo;
          else lo = hi;
        }
        minInput.value = lo;
        maxInput.value = hi;
        minRange.value = lo;
        maxRange.value = hi;
        updateFill(lo, hi);
      };

      minRange.addEventListener('input', () => {
        minInput.value = minRange.value;
        if (Number(minRange.value) > Number(maxRange.value)) {
          maxRange.value = minRange.value;
          maxInput.value = minRange.value;
        }
        syncValues('min');
      });
      maxRange.addEventListener('input', () => {
        maxInput.value = maxRange.value;
        if (Number(maxRange.value) < Number(minRange.value)) {
          minRange.value = maxRange.value;
          minInput.value = maxRange.value;
        }
        syncValues('max');
      });
      minInput.addEventListener('change', () => syncValues('min'));
      maxInput.addEventListener('input', () => syncValues('min'));
      maxInput.addEventListener('change', () => syncValues('max'));
      maxInput.addEventListener('input', () => syncValues('max'));

      syncValues();
    });
  };

  const initCollectionPage = () => {
    const grid = document.getElementById('collection-product-grid');
    const sidebar = document.getElementById('collection-sidebar');
    const overlay = document.getElementById('sidebar-overlay');
    if (!grid && !sidebar) return;

    initPriceRangeFilters(document);
    initCollectionConditionCounts();

    const defaultCols = grid?.dataset.defaultCols || '4';
    if (grid && !grid.className.includes('column-')) grid.className = `collection-grid column-${defaultCols}`;

    const openSidebar = () => {
      sidebar?.classList.add('open');
      overlay?.classList.add('active');
      document.body.style.overflow = 'hidden';
    };
    const closeSidebar = closeCollectionSidebar;
    const openBtn = qs('[data-sidebar-open]');
    if (openBtn && !openBtn.dataset.bound) {
      openBtn.dataset.bound = '1';
      openBtn.addEventListener('click', openSidebar);
    }
    qsa('[data-sidebar-close]').forEach(el => {
      if (el.dataset.bound) return;
      el.dataset.bound = '1';
      el.addEventListener('click', closeSidebar);
    });
    qsa('[data-toggle-block]').forEach(btn => {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', () => btn.closest('[data-filter-block]')?.classList.toggle('is-open'));
    });
    qsa('[data-view-as] [data-cols]').forEach(btn => {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', () => {
        qsa('[data-view-as] [data-cols]').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        if (grid) grid.className = `collection-grid column-${btn.dataset.cols}`;
      });
    });
  };

  const RECENT_MIN_DEFAULT = 10;
  const RECENT_STORE_MAX = 15;

  const productJsonCache = new Map();
  const productJsonRequests = new Map();

  const fetchProductJson = (handle) => {
    if (productJsonCache.has(handle)) return Promise.resolve(productJsonCache.get(handle));
    if (productJsonRequests.has(handle)) return productJsonRequests.get(handle);

    const request = fetch(`/products/${handle}.js`)
      .then(r => (r.ok ? r.json() : null))
      .catch(() => null)
      .then(product => {
        if (product) productJsonCache.set(handle, product);
        return product;
      })
      .finally(() => productJsonRequests.delete(handle));
    productJsonRequests.set(handle, request);
    return request;
  };

  const loadWhenNearby = (element, callback, rootMargin = '600px 0px') => {
    if (!element || element.dataset.gvfgDeferred === '1') return;
    element.dataset.gvfgDeferred = '1';

    let loaded = false;
    let observer = null;
    const load = () => {
      if (loaded) return;
      loaded = true;
      observer?.disconnect();
      callback();
    };

    if (!('IntersectionObserver' in window)) {
      window.setTimeout(load, 0);
      return;
    }

    observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) load();
    }, { rootMargin, threshold: 0.01 });
    observer.observe(element);
  };

  const collectBackfillHandles = (needed, excludeHandles, productId) => {
    if (needed <= 0) return Promise.resolve([]);

    const pickHandles = (items) => {
      const out = [];
      (items || []).forEach(item => {
        const h = item?.handle;
        if (!h || excludeHandles.has(h)) return;
        out.push(h);
        excludeHandles.add(h);
      });
      return out;
    };

    const fillFromCollection = (current) => {
      const stillNeed = needed - current.length;
      if (stillNeed <= 0) return Promise.resolve(current.slice(0, needed));
      return fetch('/collections/all/products.json?limit=50')
        .then(r => (r.ok ? r.json() : { products: [] }))
        .then(data => current.concat(pickHandles(data.products)).slice(0, needed))
        .catch(() => current.slice(0, needed));
    };

    if (productId) {
      return fetch(`/recommendations/products.json?product_id=${productId}&limit=${needed + 10}&intent=related`)
        .then(r => (r.ok ? r.json() : { products: [] }))
        .then(data => {
          const handles = pickHandles(data.products);
          if (handles.length >= needed) return handles.slice(0, needed);
          return fillFromCollection(handles);
        })
        .catch(() => fillFromCollection([]));
    }

    return fillFromCollection([]);
  };

  const initRecentlyViewed = () => {
    const section = document.querySelector('[data-recently-viewed]');
    const scroll = document.getElementById('recently-viewed-scroll');
    if (!section || !scroll) return;

    loadWhenNearby(section, () => {

      const minCount = Math.max(4, parseInt(section.dataset.minCount || String(RECENT_MIN_DEFAULT), 10) || RECENT_MIN_DEFAULT);
      const currentHandle = section.dataset.currentHandle
        || (document.body.classList.contains('template-product')
          ? (window.location.pathname.split('/').filter(Boolean).pop() || '')
          : '');
      const productId = section.dataset.productId || '';

      let handles = [];
      try { handles = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (_) {}
      handles = handles.filter(h => h && h !== currentHandle);

      const excludeHandles = new Set(handles);
      if (currentHandle) excludeHandles.add(currentHandle);

      const renderRecent = (products) => {
        const valid = products.filter(Boolean).slice(0, minCount);
        if (!valid.length) {
          section.hidden = true;
          return;
        }
        section.hidden = false;
        scroll.innerHTML = valid.map(renderProductCard).join('');
        initSliders(section);
        syncWishlistButtons();
        fetchCart().then(cart => syncCartAddButtons(cart)).catch(() => {});
      };

      Promise.all(handles.slice(0, minCount).map(fetchProductJson))
        .then(products => {
          const valid = products.filter(Boolean);
          const needed = minCount - valid.length;
          if (needed <= 0) return valid.slice(0, minCount);
          return collectBackfillHandles(needed, excludeHandles, productId)
            .then(extraHandles => Promise.all(extraHandles.map(fetchProductJson)))
            .then(extra => valid.concat(extra.filter(Boolean)).slice(0, minCount));
        })
        .then(renderRecent)
        .catch(() => { section.hidden = true; });
    });
  };

  const initRecommendations = () => {
    qsa('[data-product-recommendations]').forEach(wrapper => {
      if (wrapper.dataset.loaded || wrapper.querySelector('.product-related')) return;
      const url = wrapper.dataset.url;
      if (!url) return;
      loadWhenNearby(wrapper, () => {
        fetch(url)
          .then(r => r.text())
          .then(html => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const content = doc.querySelector('.product-recommendations-wrapper');
            if (content?.innerHTML.trim() && content.querySelector('.product-related')) {
              wrapper.innerHTML = content.innerHTML;
              wrapper.dataset.loaded = '1';
              initSliders(wrapper);
              syncWishlistButtons();
            }
          })
          .catch(() => {});
      });
    });
  };

  const initProductImageLightbox = () => {
    const gallery = document.querySelector('[data-product-gallery]');
    const lightbox = document.getElementById('productImageLightbox');
    if (!gallery || !lightbox) return;

    const images = (gallery.dataset.productImages || '').split('|').filter(Boolean);
    if (!images.length) return;

    const imgEl = document.getElementById('productLightboxImg');
    const prevBtn = lightbox.querySelector('[data-lightbox-prev]');
    const nextBtn = lightbox.querySelector('[data-lightbox-next]');
    const trigger = gallery.querySelector('[data-product-image-open]');
    let currentIdx = 0;

    const getCurrentIndex = () => {
      const activeSlide = gallery.querySelector('[data-gallery-slide].is-active');
      if (activeSlide?.dataset.galleryIndex != null) return parseInt(activeSlide.dataset.galleryIndex, 10);
      const activeThumb = gallery.querySelector('.product-thumb.active');
      if (activeThumb?.dataset.galleryThumb != null) return parseInt(activeThumb.dataset.galleryThumb, 10);
      if (activeThumb?.dataset.image) {
        const idx = images.indexOf(activeThumb.dataset.image);
        if (idx >= 0) return idx;
      }
      const main = document.getElementById('ProductImage');
      if (main?.src) {
        const idx = images.findIndex(url => main.src.includes(url.split('?')[0]) || url.includes(main.src.split('?')[0]));
        if (idx >= 0) return idx;
      }
      return 0;
    };

    const show = (idx) => {
      currentIdx = (idx + images.length) % images.length;
      if (imgEl) {
        imgEl.src = images[currentIdx];
        imgEl.alt = gallery.dataset.productTitle || '';
      }
      const multi = images.length > 1;
      if (prevBtn) prevBtn.hidden = !multi;
      if (nextBtn) nextBtn.hidden = !multi;
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
    };

    const close = () => {
      lightbox.hidden = true;
      document.body.style.overflow = '';
    };

    trigger?.addEventListener('click', e => {
      if (e.target.closest('.product-discount-badge')) return;
      show(getCurrentIndex());
    });
    trigger?.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        show(getCurrentIndex());
      }
    });

    lightbox.querySelectorAll('[data-lightbox-close]').forEach(el => el.addEventListener('click', close));
    prevBtn?.addEventListener('click', e => { e.stopPropagation(); show(currentIdx - 1); });
    nextBtn?.addEventListener('click', e => { e.stopPropagation(); show(currentIdx + 1); });
    document.addEventListener('keydown', e => {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(currentIdx - 1);
      if (e.key === 'ArrowRight') show(currentIdx + 1);
    });
  };

  const initProductZoom = () => {
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!canHover) return;
    qsa('.product-zoom-wrap').forEach(wrap => {
      if (wrap.dataset.zoomReady) return;
      const img = wrap.querySelector('.product-main-image, #ProductImage');
      if (!img) return;
      const scale = parseFloat(wrap.dataset.zoomScale) || 2;
      const reset = () => {
        wrap.classList.remove('is-zooming');
        img.style.transform = '';
        img.style.transformOrigin = '';
      };
      let zoomW = 0;
      let zoomH = 0;
      wrap.addEventListener('mouseenter', () => {
        zoomW = wrap.clientWidth;
        zoomH = wrap.clientHeight;
      });
      wrap.addEventListener('mousemove', e => {
        if (!zoomW || !zoomH) return;
        const x = (e.offsetX / zoomW) * 100;
        const y = (e.offsetY / zoomH) * 100;
        wrap.classList.add('is-zooming');
        img.style.transformOrigin = `${x}% ${y}%`;
        img.style.transform = `scale(${scale})`;
      });
      wrap.addEventListener('mouseleave', reset);
      wrap.dataset.zoomReady = '1';
    });
  };

  const initProductGallerySlider = () => {
    const slider = document.querySelector('[data-product-gallery-slider].has-multiple');
    if (!slider) return;

    const track = slider.querySelector('[data-gallery-track]');
    const slides = qsa('[data-gallery-slide]', slider);
    const prev = slider.querySelector('[data-gallery-prev]');
    const next = slider.querySelector('[data-gallery-next]');
    const dots = qsa('[data-gallery-dot]', slider);
    const thumbs = qsa('[data-gallery-thumb]');
    let idx = 0;
    let touchStartX = 0;

    const syncSlides = () => {
      slides.forEach((slide, n) => {
        slide.classList.toggle('is-active', n === idx);
        const img = slide.querySelector('img');
        if (img) {
          if (n === idx) img.id = 'ProductImage';
          else img.removeAttribute('id');
        }
      });
      dots.forEach((d, n) => d.classList.toggle('is-active', n === idx));
      thumbs.forEach((t, n) => t.classList.toggle('active', n === idx));
    };

    const goTo = (i) => {
      idx = (i + slides.length) % slides.length;
      if (track) track.style.transform = `translate3d(-${idx * 100}%, 0, 0)`;
      syncSlides();
      const activeImg = slides[idx]?.querySelector('img');
      if (activeImg) {
        activeImg.style.transform = '';
        activeImg.style.transformOrigin = '';
      }
    };

    window.gvfgGalleryGoTo = (imageSrc) => {
      if (!imageSrc) return;
      const clean = String(imageSrc).split('?')[0];
      const match = slides.findIndex(slide => {
        const url = slide.dataset.image || '';
        const img = slide.querySelector('img');
        return url === clean || url.includes(clean.split('/').pop() || '') || (img?.src && img.src.split('?')[0].includes(clean.split('/').pop() || ''));
      });
      if (match >= 0) goTo(match);
    };

    prev?.addEventListener('click', e => { e.stopPropagation(); goTo(idx - 1); });
    next?.addEventListener('click', e => { e.stopPropagation(); goTo(idx + 1); });
    dots.forEach(d => d.addEventListener('click', e => {
      e.stopPropagation();
      goTo(parseInt(d.dataset.galleryDot, 10));
    }));
    thumbs.forEach(t => t.addEventListener('click', e => {
      e.stopPropagation();
      goTo(parseInt(t.dataset.galleryThumb, 10));
    }));

    const viewport = slider.querySelector('[data-gallery-viewport]');
    viewport?.addEventListener('touchstart', e => { touchStartX = e.changedTouches[0].clientX; }, { passive: true });
    viewport?.addEventListener('touchend', e => {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 45) goTo(diff > 0 ? idx + 1 : idx - 1);
    }, { passive: true });

    const frame = slider.querySelector('[data-product-image-open]');
    frame?.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(idx - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(idx + 1); }
    });

    goTo(0);
  };

  const initProductPage = () => {
    if (!document.body.classList.contains('template-product')) return;
    const handle = window.location.pathname.split('/').filter(Boolean).pop();
    if (handle) {
      let recent = [];
      try { recent = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (_) {}
      recent = recent.filter(h => h !== handle);
      recent.unshift(handle);
      localStorage.setItem(RECENT_KEY, JSON.stringify(recent.slice(0, RECENT_STORE_MAX)));
    }
    initProductMeasurementsModal();
  };

  const initProductMeasurementsModal = () => {
    const modal = document.querySelector('[data-measurements-modal]');
    const openBtn = document.querySelector('[data-measurements-open]');
    if (!modal || !openBtn) return;

    const open = () => {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      const closeBtn = modal.querySelector('[data-measurements-close]');
      closeBtn?.focus?.();
    };
    const close = () => {
      modal.hidden = true;
      document.body.style.overflow = '';
      openBtn.focus?.();
    };

    openBtn.addEventListener('click', (e) => {
      e.preventDefault();
      open();
    });
    modal.querySelectorAll('[data-measurements-close]').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        close();
      });
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  };

  const initProductForm = () => {
    const form = document.querySelector('[data-product-form]');
    if (!form) return;
    form.addEventListener('submit', async e => {
      const availableBlock = qs('[data-product-actions-available]', form);
      const soldOutBtn = qs('[data-product-sold-out-btn]', form);
      if (availableBlock?.hidden || (soldOutBtn && !soldOutBtn.hidden)) {
        e.preventDefault();
        return;
      }
      e.preventDefault();
      const variantInput = qs('[data-variant-id]', form);
      const qtyInput = qs('[data-product-qty]', form) || document.getElementById('Quantity');
      const variantId = variantInput?.value;
      const quantity = Math.max(1, parseInt(qtyInput?.value || '1', 10));
      const btn = qs('[data-add-to-cart]', form);
      if (!variantId) return;
      if (btn?.classList.contains('is-added')) {
        openCartDrawer();
        return;
      }

      try {
        const cart = await fetchCart();
        const maxInv = await resolveVariantInventoryMax(variantId, btn);
        const remaining = getRemainingCartQty(cart, variantId, maxInv);
        if (remaining === 0 || quantity <= 0) {
          markAtcButtonAdded(btn);
          refreshProductPageQtyState(cart);
          openCartDrawer();
          return;
        }
        if (remaining !== Infinity && quantity > remaining) {
          if (qtyInput) qtyInput.value = String(Math.max(1, remaining));
          return;
        }
        ensureAtcLabelDefault(btn);
        if (btn) {
          btn.disabled = true;
          btn.textContent = 'Adding…';
        }
        await addToCartRequest(variantId, quantity);
        const updatedCart = await resolveAtcButtonAfterAdd(btn, variantId, btn);
        if (updatedCart) refreshProductPageQtyState(updatedCart);
        openCartDrawer();
      } catch (_) {
        if (btn && !btn.classList.contains('is-added')) resetAtcButton(btn);
      }
    });
  };

  const redirectToCheckout = () => {
    window.location.href = window.GVFG?.routes?.checkout || '/checkout';
  };

  const redirectToCheckoutWithVariant = (variantId, quantity) => {
    const qty = Math.max(1, parseInt(quantity, 10) || 1);
    window.location.href = `${shopRoot()}cart/${variantId}:${qty}?checkout`;
  };

  const initBuyNow = () => {
    document.addEventListener('click', async e => {
      const btn = e.target.closest('[data-buy-now]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      const form = btn.closest('[data-product-form]') || document.querySelector('[data-product-form]');
      const variantInput = form ? qs('[data-variant-id]', form) : null;
      const qtyInput = form ? (qs('[data-product-qty]', form) || document.getElementById('Quantity')) : null;
      const atcBtn = form ? qs('[data-add-to-cart]', form) : null;
      const variantId = variantInput?.value;
      const requestedQty = Math.max(1, parseInt(qtyInput?.value || '1', 10));
      const label = btn.dataset.label || btn.textContent;
      if (!variantId) return;

      const availableBlock = qs('[data-product-actions-available]', form);
      const soldOutBtn = qs('[data-product-sold-out-btn]', form);
      if (availableBlock?.hidden || (soldOutBtn && !soldOutBtn.hidden)) return;

      btn.disabled = true;
      btn.textContent = 'Processing…';

      try {
        const handle = window.location.pathname.split('/').filter(Boolean).pop() || '';
        const cart = await fetchCart();
        const maxInv = await resolveVariantInventoryMax(variantId, atcBtn || btn, handle);
        const inCart = getCartQtyForVariant(cart, variantId);
        const remaining = getRemainingCartQty(cart, variantId, maxInv);

        if (atcBtn) refreshProductPageQtyState(cart);

        if (inCart > 0 && (remaining === 0 || inCart >= requestedQty)) {
          redirectToCheckout();
          return;
        }

        if (remaining === 0 && inCart === 0) {
          btn.disabled = false;
          btn.textContent = label;
          return;
        }

        const addQty = remaining === Infinity
          ? requestedQty
          : Math.min(requestedQty, remaining);

        if (addQty <= 0) {
          if (inCart > 0) redirectToCheckout();
          else {
            btn.disabled = false;
            btn.textContent = label;
          }
          return;
        }

        redirectToCheckoutWithVariant(variantId, addQty);
      } catch (_) {
        try {
          const cart = await fetchCart();
          if (getCartQtyForVariant(cart, variantId) > 0) {
            redirectToCheckout();
            return;
          }
        } catch (__) {}
        btn.disabled = false;
        btn.textContent = label;
      }
    });
  };

  const getCardAtcVariantId = (btn) => {
    if (!btn) return '';
    if (btn.dataset.variantId) return btn.dataset.variantId;
    const form = btn.closest('.card-atc-form');
    const input = form?.querySelector('[name="id"]');
    return input?.value || '';
  };

  const handleCardAddToCart = async (btn) => {
    if (!btn || (btn.disabled && !btn.classList.contains('is-added'))) return;
    if (btn.classList.contains('is-added')) {
      openCartDrawer();
      return;
    }
    const variantId = getCardAtcVariantId(btn);
    if (!variantId) return;
    const handle = btn.closest('[data-product-handle]')?.dataset.productHandle
      || btn.closest('[data-quick-view-form]')?.dataset.productHandle
      || document.getElementById('quickViewModal')?.dataset.productHandle
      || '';

    try {
      const cart = await fetchCart();
      const maxInv = await resolveVariantInventoryMax(variantId, btn, handle);
      const remaining = getRemainingCartQty(cart, variantId, maxInv);
      if (remaining === 0) {
        markAtcButtonAdded(btn);
        openCartDrawer();
        return;
      }
      ensureAtcLabelDefault(btn);
      btn.disabled = true;
      btn.textContent = 'Adding…';
      const addQty = remaining === Infinity ? 1 : Math.min(1, remaining);
      if (addQty <= 0) {
        markAtcButtonAdded(btn);
        openCartDrawer();
        return;
      }
      await addToCartRequest(variantId, addQty);
      const updatedCart = await resolveAtcButtonAfterAdd(btn, variantId, btn, handle);
      if (updatedCart) updateCartBadges(updatedCart.item_count);
      await syncCartAddButtons(updatedCart);
      if (!btn.matches('[data-wishlist-atc]')) openCartDrawer();
    } catch (_) {
      if (!btn.classList.contains('is-added')) resetAtcButton(btn);
    }
  };

  const initCardAddToCart = () => {
    document.addEventListener('submit', e => {
      const form = e.target.closest('.card-atc-form');
      if (!form) return;
      e.preventDefault();
      handleCardAddToCart(form.querySelector('[data-add-to-cart-card]'));
    });
    document.addEventListener('click', e => {
      const btn = e.target.closest('[data-add-to-cart-card]');
      if (!btn || (btn.disabled && !btn.classList.contains('is-added'))) return;
      if (btn.type === 'submit' && !btn.classList.contains('is-added')) return;
      e.preventDefault();
      e.stopPropagation();
      handleCardAddToCart(btn);
    });
  };

  const initCartDrawer = () => {
    document.addEventListener('click', e => {
      const openBtn = e.target.closest('[data-cart-drawer-open]');
      if (openBtn) {
        e.preventDefault();
        openCartDrawer();
        return;
      }

      const closeBtn = e.target.closest('[data-cart-drawer-close]');
      if (closeBtn) {
        e.preventDefault();
        closeCartDrawer();
        return;
      }

      const minusBtn = e.target.closest('[data-cart-qty-minus]');
      if (minusBtn) {
        e.preventDefault();
        const key = minusBtn.dataset.cartQtyMinus;
        const valueEl = document.querySelector(`[data-cart-qty-value="${key}"]`);
        const nextQty = Math.max(0, parseInt(valueEl?.textContent || '1', 10) - 1);
        changeCartLine(key, nextQty).then(renderCartDrawer).catch(() => {});
        return;
      }

      const plusBtn = e.target.closest('[data-cart-qty-plus]');
      if (plusBtn) {
        e.preventDefault();
        const key = plusBtn.dataset.cartQtyPlus;
        const valueEl = document.querySelector(`[data-cart-qty-value="${key}"]`);
        const itemEl = plusBtn.closest('[data-cart-item]');
        const variantId = itemEl?.dataset.variantId;
        const handle = itemEl?.dataset.productHandle;
        const nextQty = parseInt(valueEl?.textContent || '1', 10) + 1;
        resolveVariantInventoryMax(variantId, null, handle)
          .then(maxInv => fetchCart().then(cart => ({ maxInv, cart })))
          .then(({ maxInv, cart }) => {
            const remaining = getRemainingCartQty(cart, variantId, maxInv);
            if (remaining === 0) return null;
            const cappedQty = maxInv === null ? nextQty : Math.min(nextQty, getCartQtyForVariant(cart, variantId) + remaining);
            return changeCartLine(key, cappedQty);
          })
          .then(cart => { if (cart) renderCartDrawer(cart); })
          .catch(() => {});
        return;
      }

      const removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        e.preventDefault();
        changeCartLine(removeBtn.dataset.cartRemove, 0).then(renderCartDrawer).catch(() => {});
        return;
      }

      const drawerCheckoutBtn = e.target.closest('[data-cart-drawer-checkout]');
      if (drawerCheckoutBtn) {
        e.preventDefault();
        if (!requireCartPhone()) return;
        const phoneInput = getActiveCartPhoneInput();
        saveCartPhone(phoneInput?.value || '')
          .then(() => { window.location.href = window.GVFG?.routes?.checkout || '/checkout'; })
          .catch(() => { window.location.href = window.GVFG?.routes?.checkout || '/checkout'; });
        return;
      }

      const wishlistAtcBtn = e.target.closest('[data-wishlist-atc]');
      if (wishlistAtcBtn) {
        e.preventDefault();
        e.stopPropagation();
        handleCardAddToCart(wishlistAtcBtn);
      }
    });

    document.addEventListener('keydown', e => {
      const drawer = document.getElementById('cartDrawer');
      if (e.key === 'Escape' && drawer && !drawer.hidden) closeCartDrawer();
    });

  };

  const showCartDiscountMessage = (message, type = 'error') => {
    const el = document.getElementById('cartPageDiscountMessage');
    if (!el) return;
    if (!message) {
      el.hidden = true;
      el.textContent = '';
      el.classList.remove('is-error', 'is-success');
      return;
    }
    el.textContent = message;
    el.hidden = false;
    el.classList.toggle('is-error', type === 'error');
    el.classList.toggle('is-success', type === 'success');
  };

  const formatPromoDiscountError = (remainingCents, code, minSubtotal) => {
    const cfg = window.GVFG?.promoDiscount || {};
    const tpl = cfg.minSubtotalError
      || 'Add __AMOUNT__ more to use code __CODE__. Minimum order is __MIN__ for this discount.';
    const amountText = formatMoney(remainingCents);
    const minText = `Rs.${Number(minSubtotal || cfg.minSubtotal || 4000).toLocaleString()}`;
    return tpl
      .replaceAll('__AMOUNT__', amountText)
      .replaceAll('{{ amount }}', amountText)
      .replaceAll('__CODE__', code)
      .replaceAll('{{ code }}', code)
      .replaceAll('__MIN__', minText)
      .replaceAll('{{ min }}', minText);
  };

  const applyDiscountCode = (code, redirect = '/cart') => {
    const normalized = String(code || '').trim().toUpperCase();
    if (!normalized) {
      showCartDiscountMessage(window.GVFG?.promoDiscount?.invalidError || 'Enter a valid discount code.');
      return Promise.resolve(false);
    }

    return fetchCart()
      .then(cart => {
        const promo = window.GVFG?.promoDiscount || {};
        const promoCode = String(promo.code || 'GVFG10').trim().toUpperCase();
        if (normalized === promoCode) {
          const minSubtotal = Number(promo.minSubtotal || 4000) * 100;
          const subtotal = cart.items_subtotal_price || 0;
          if (subtotal < minSubtotal) {
            showCartDiscountMessage(
              formatPromoDiscountError(minSubtotal - subtotal, promoCode, promo.minSubtotal)
            );
            return false;
          }
        }
        showCartDiscountMessage('');
        window.location.href = `/discount/${encodeURIComponent(normalized)}?redirect=${encodeURIComponent(redirect)}`;
        return true;
      })
      .catch(() => {
        window.location.href = `/discount/${encodeURIComponent(normalized)}?redirect=${encodeURIComponent(redirect)}`;
        return true;
      });
  };

  const refreshCartPageSection = () => {
    const root = document.querySelector('[data-cart-page]');
    const sectionId = root?.dataset.sectionId;
    if (!sectionId) {
      window.location.reload();
      return Promise.resolve();
    }
    return fetch(`${window.location.pathname}?sections=${sectionId}`)
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(data => {
        const html = data[sectionId];
        if (!html || !root) {
          window.location.reload();
          return;
        }
        const tpl = document.createElement('div');
        tpl.innerHTML = html;
        const next = tpl.querySelector('[data-cart-page]');
        if (!next) {
          window.location.reload();
          return;
        }
        root.innerHTML = next.innerHTML;
        if (next.dataset.sectionId) root.dataset.sectionId = next.dataset.sectionId;
        return fetchCart();
      })
      .then(cart => {
        if (cart) updateCartBadges(cart.item_count);
      })
      .catch(() => { window.location.reload(); });
  };

  const initCartPhone = () => {
    let phoneTimer;
    document.addEventListener('input', e => {
      const input = e.target.closest('[data-cart-phone-input]');
      if (!input) return;
      setCartPhoneFieldState(input, true);
      clearTimeout(phoneTimer);
      phoneTimer = setTimeout(() => {
        if (isValidCartPhone(input.value)) saveCartPhone(input.value).catch(() => {});
      }, 500);
    });
  };

  const initCartPage = () => {
    const cartPage = document.querySelector('[data-cart-page]');
    if (!cartPage) return;

    let noteTimer;

    const cartForm = document.querySelector('[data-cart-page-form]');
    cartForm?.addEventListener('submit', e => {
      const submitter = e.submitter;
      if (!submitter || submitter.name !== 'checkout') return;
      e.preventDefault();
      if (!requireCartPhone()) return;
      const phoneInput = getActiveCartPhoneInput();
      saveCartPhone(phoneInput?.value || '')
        .then(() => { window.location.href = window.GVFG?.routes?.checkout || '/checkout'; })
        .catch(() => { window.location.href = window.GVFG?.routes?.checkout || '/checkout'; });
    });

    document.addEventListener('click', e => {
      const minusBtn = e.target.closest('[data-cart-page-qty-minus]');
      if (minusBtn) {
        e.preventDefault();
        const key = minusBtn.dataset.cartPageQtyMinus;
        const valueEl = document.querySelector(`[data-cart-page-qty-value="${key}"]`);
        const nextQty = Math.max(0, parseInt(valueEl?.textContent || '1', 10) - 1);
        changeCartLine(key, nextQty).then(refreshCartPageSection).catch(() => {});
        return;
      }

      const plusBtn = e.target.closest('[data-cart-page-qty-plus]');
      if (plusBtn) {
        e.preventDefault();
        const key = plusBtn.dataset.cartPageQtyPlus;
        const valueEl = document.querySelector(`[data-cart-page-qty-value="${key}"]`);
        const nextQty = parseInt(valueEl?.textContent || '1', 10) + 1;
        changeCartLine(key, nextQty).then(refreshCartPageSection).catch(() => {});
        return;
      }

      const removeBtn = e.target.closest('[data-cart-page-remove]');
      if (removeBtn) {
        e.preventDefault();
        changeCartLine(removeBtn.dataset.cartPageRemove, 0).then(refreshCartPageSection).catch(() => {});
        return;
      }

      const toolBtn = e.target.closest('[data-cart-tool-toggle]');
      if (toolBtn) {
        e.preventDefault();
        const target = toolBtn.dataset.cartToolToggle;
        const panel = document.querySelector(`[data-cart-panel="${target}"]`);
        if (!panel) return;
        const willOpen = panel.hidden;
        qsa('[data-cart-panel]').forEach(p => { p.hidden = true; });
        qsa('[data-cart-tool-toggle]').forEach(b => b.setAttribute('aria-expanded', 'false'));
        if (willOpen) {
          panel.hidden = false;
          toolBtn.setAttribute('aria-expanded', 'true');
        }
        return;
      }

      const discountBtn = e.target.closest('[data-cart-page-discount-apply]');
      if (discountBtn) {
        e.preventDefault();
        const input = document.querySelector('[data-cart-page-discount]');
        const code = input?.value?.trim();
        if (!code) {
          showCartDiscountMessage(window.GVFG?.promoDiscount?.invalidError || 'Enter a valid discount code.');
          return;
        }
        discountBtn.disabled = true;
        applyDiscountCode(code, '/cart').finally(() => {
          discountBtn.disabled = false;
        });
      }
    });

    document.addEventListener('input', e => {
      const note = e.target.closest('[data-cart-page-note]');
      if (!note) return;
      clearTimeout(noteTimer);
      noteTimer = setTimeout(() => {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: note.value })
        }).catch(() => {});
      }, 500);
    });
  };

  const parseSearchTerms = raw => (raw || '').replace(/^title:\s*/i, '').trim();

  const toTitleSearchQuery = term => {
    const cleaned = parseSearchTerms(term);
    return cleaned ? `title:${cleaned}` : '';
  };

  const productTitleMatches = (title, term) => {
    const titleDown = (title || '').toLowerCase();
    const termDown = parseSearchTerms(term).toLowerCase();
    if (!termDown) return false;
    return titleDown.includes(termDown);
  };

  const initTitleSearch = () => {
    const normalizeSearchUrl = (form, term) => {
      const url = new URL(form.getAttribute('action') || '/search', window.location.origin);
      url.searchParams.set('q', toTitleSearchQuery(term));
      url.searchParams.set('type', 'product');
      return url;
    };

    qsa('[data-title-search-form]').forEach(form => {
      form.addEventListener('submit', e => {
        const input = form.querySelector('[name="q"], [data-search-input]');
        const term = parseSearchTerms(input?.value || '');
        if (!term) return;
        e.preventDefault();
        window.location.href = normalizeSearchUrl(form, term).toString();
      });
    });

    if (!document.querySelector('.search-page')) return;

    const params = new URLSearchParams(window.location.search);
    const rawQuery = params.get('q') || '';
    const displayTerm = parseSearchTerms(rawQuery);
    if (!displayTerm) return;

    if (!/^title:\s*/i.test(rawQuery)) {
      params.set('q', toTitleSearchQuery(displayTerm));
      params.set('type', 'product');
      window.location.replace(`${window.location.pathname}?${params.toString()}`);
      return;
    }

    const grid = document.querySelector('[data-search-results-grid]');
    if (!grid) return;

    let visible = 0;
    qsa('.product-card', grid).forEach(card => {
      const title = card.dataset.productTitle || card.querySelector('h3')?.textContent?.trim() || '';
      const match = productTitleMatches(title, displayTerm);
      card.hidden = !match;
      if (match) visible += 1;
    });

    const heading = document.querySelector('[data-search-heading]');
    const countEl = document.querySelector('[data-search-count]');
    const noResults = document.querySelector('[data-search-no-results]');
    if (visible === 0) {
      grid.hidden = true;
      if (countEl) countEl.hidden = true;
      if (heading) heading.textContent = `No results found for "${displayTerm}"`;
      if (!noResults) {
        const p = document.createElement('p');
        p.className = 'search-no-results';
        p.setAttribute('data-search-no-results', '');
        p.textContent = `No results found for "${displayTerm}"`;
        grid.parentElement?.appendChild(p);
      }
    } else {
      if (heading) heading.textContent = `${visible} result${visible === 1 ? '' : 's'} found for "${displayTerm}"`;
      if (countEl) countEl.textContent = `${visible} product${visible === 1 ? '' : 's'} found`;
    }
  };

  const renderPredictiveItem = product => {
    const price = parseFloat(product.price_min || product.price || 0) * 100;
    const compare = parseFloat(product.compare_at_price_min || product.compare_at_price_max || 0) * 100;
    const img = product.featured_image?.url || product.image;
    const compareHtml = compare > price
      ? `<span class="predictive-search-compare">${formatMoney(compare)}</span>`
      : '';
    const url = product.url?.split('?')[0] || `/products/${product.handle}`;
    return `
      <li role="option">
        <a href="${url}" class="predictive-search-item">
          <span class="predictive-search-image">
            ${img ? `<img src="${img}" alt="${product.title.replace(/"/g, '')}" width="56" height="70" loading="lazy">` : ''}
          </span>
          <span class="predictive-search-info">
            <span class="predictive-search-title">${product.title}</span>
            <span class="predictive-search-price">
              <span class="predictive-search-sale">${formatMoney(price)}</span>
              ${compareHtml}
            </span>
          </span>
        </a>
      </li>`;
  };

  const initPredictiveSearch = () => {
    const form = document.querySelector('[data-predictive-search-form]');
    const input = form?.querySelector('[data-search-input]');
    const panel = document.getElementById('predictiveSearchPanel');
    const list = document.getElementById('predictiveSearchList');
    const viewAll = document.getElementById('predictiveSearchViewAll');
    const status = document.getElementById('predictiveSearchStatus');
    if (!form || !input || !panel || !list) return;

    let debounceTimer;
    let activeController;
    const searchHistoryKey = 'gvfg_recent_product_searches_v1';
    const searchHistoryLimit = 6;

    const getSearchHistory = () => {
      try {
        const saved = JSON.parse(window.localStorage.getItem(searchHistoryKey) || '[]');
        return Array.isArray(saved)
          ? saved.filter(term => typeof term === 'string' && term.trim().length > 1).slice(0, searchHistoryLimit)
          : [];
      } catch (error) {
        return [];
      }
    };

    const saveSearchHistory = term => {
      const cleaned = parseSearchTerms(term).trim().replace(/\s+/g, ' ');
      if (cleaned.length < 2) return;
      try {
        const next = [cleaned]
          .concat(getSearchHistory().filter(item => item.toLowerCase() !== cleaned.toLowerCase()))
          .slice(0, searchHistoryLimit);
        window.localStorage.setItem(searchHistoryKey, JSON.stringify(next));
      } catch (error) {}
    };

    const hidePanel = () => {
      panel.hidden = true;
      list.innerHTML = '';
      if (viewAll) viewAll.hidden = true;
      if (status) status.textContent = '';
    };

    const showSearchHistory = () => {
      const searches = getSearchHistory();
      if (!searches.length) {
        hidePanel();
        return;
      }
      list.innerHTML = `
        <li class="gvfg-ps-history-head">
          <span>Recent searches</span>
          <button class="gvfg-ps-history-clear" type="button">Clear</button>
        </li>
        ${searches.map(term => `
          <li class="gvfg-ps-history-item">
            <a href="/search?q=${encodeURIComponent(toTitleSearchQuery(term))}&type=product" data-recent-search="${escapeHtml(term)}">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 8v5l3.5 2"></path><path d="M3.1 12a8.9 8.9 0 1 0 2.6-6.3L3 8.4"></path><path d="M3 3v5.4h5.4"></path></svg>
              <span>${escapeHtml(term)}</span>
            </a>
          </li>`).join('')}`;
      if (viewAll) viewAll.hidden = true;
      if (status) status.textContent = 'Recent searches';
      panel.hidden = false;
    };

    const showResults = products => {
      list.innerHTML = products.map(renderPredictiveItem).join('');
      panel.hidden = products.length === 0;
      if (viewAll) viewAll.hidden = products.length === 0;
      if (status) {
        status.textContent = products.length
          ? `${products.length} suggestion${products.length === 1 ? '' : 's'}`
          : '';
      }
    };

    const fetchSuggestions = query => {
      const trimmed = query.trim();
      if (trimmed.length < 2) {
        showSearchHistory();
        return;
      }
      if (activeController) activeController.abort();
      activeController = new AbortController();
      const titleQuery = toTitleSearchQuery(trimmed);
      const url = `/search/suggest.json?q=${encodeURIComponent(titleQuery)}&resources[type]=product&resources[limit]=12&resources[options][unavailable_products]=hide`;
      fetch(url, { signal: activeController.signal })
        .then(r => r.ok ? r.json() : Promise.reject())
        .then(data => {
          const products = (data?.resources?.results?.products || [])
            .filter(product => productTitleMatches(product.title, trimmed))
            .slice(0, 4);
          showResults(products);
          if (viewAll) {
            viewAll.href = `/search?q=${encodeURIComponent(titleQuery)}&type=product`;
          }
          if (status && !products.length) {
            status.textContent = `No products found for “${trimmed}”`;
            panel.hidden = false;
          }
        })
        .catch(err => {
          if (err?.name !== 'AbortError') hidePanel();
        });
    };

    input.addEventListener('input', () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => fetchSuggestions(input.value), 200);
    });

    input.addEventListener('focus', () => {
      if (input.value.trim().length >= 2) fetchSuggestions(input.value);
      else showSearchHistory();
    });

    form.addEventListener('submit', () => saveSearchHistory(input.value));
    list.addEventListener('click', event => {
      const clear = event.target.closest('.gvfg-ps-history-clear');
      if (clear) {
        try { window.localStorage.removeItem(searchHistoryKey); } catch (error) {}
        showSearchHistory();
        input.focus();
        return;
      }
      if (event.target.closest('.predictive-search-item')) saveSearchHistory(input.value);
      const recent = event.target.closest('[data-recent-search]');
      if (recent) saveSearchHistory(recent.getAttribute('data-recent-search'));
    });

    document.addEventListener('click', e => {
      if (!form.contains(e.target) && !panel.contains(e.target)) hidePanel();
    });

    form.addEventListener('submit', hidePanel);
  };

  const initUI = () => {
    const searchToggle = document.getElementById('searchToggle');
    const searchOverlay = document.getElementById('searchOverlay');
    const searchClose = document.getElementById('searchClose');
    const bottomSearch = document.getElementById('bottomSearch');
    const openSearch = () => {
      searchOverlay?.classList.add('active');
      const input = searchOverlay?.querySelector('[data-search-input], input[name="q"]');
      input?.focus();
      if (input?.value.trim().length >= 2) input.dispatchEvent(new Event('input', { bubbles: true }));
    };
    const closeSearch = () => {
      searchOverlay?.classList.remove('active');
      document.getElementById('predictiveSearchPanel')?.setAttribute('hidden', '');
    };
    searchToggle?.addEventListener('click', openSearch);
    bottomSearch?.addEventListener('click', openSearch);
    searchClose?.addEventListener('click', closeSearch);

    const mobileMenu = document.getElementById('mobileMenu');
    const overlay = document.getElementById('overlay');
    const menuToggle = document.getElementById('menuToggle');
    const openMenu = () => {
      mobileMenu?.classList.add('open');
      overlay?.classList.add('active');
      document.body.style.overflow = 'hidden';
      menuToggle?.setAttribute('aria-expanded', 'true');
      mobileMenu?.setAttribute('aria-hidden', 'false');
      mobileMenu?.removeAttribute('inert');
    };
    const closeMenu = () => {
      mobileMenu?.classList.remove('open');
      overlay?.classList.remove('active');
      document.body.style.overflow = '';
      menuToggle?.setAttribute('aria-expanded', 'false');
      mobileMenu?.setAttribute('aria-hidden', 'true');
      mobileMenu?.setAttribute('inert', '');
    };
    menuToggle?.addEventListener('click', openMenu);
    document.getElementById('menuClose')?.addEventListener('click', closeMenu);
    overlay?.addEventListener('click', () => { closeMenu(); closeSearch(); closeWishlistDrawer(); closeCartDrawer(); });

    const heroSlides = qsa('.hero-mts-slide, .hero-slide');
    const heroDots = qsa('.hero-mts-dot, .hero-dot');
    let heroIdx = 0;
    const goHero = i => {
      if (!heroSlides.length) return;
      heroSlides[heroIdx]?.classList.remove('active');
      heroDots[heroIdx]?.classList.remove('active');
      heroIdx = i;
      heroSlides[heroIdx]?.classList.add('active');
      heroDots[heroIdx]?.classList.add('active');
    };
    heroDots.forEach(d => d.addEventListener('click', () => goHero(parseInt(d.dataset.slide, 10))));
    if (heroSlides.length > 1) {
      createVisibilityInterval(() => goHero((heroIdx + 1) % heroSlides.length), 5000);
    }

    if (!document.querySelector('[data-product-gallery-slider].has-multiple')) {
      const mainImage = document.getElementById('ProductImage');
      qsa('.product-thumb').forEach(thumb => thumb.addEventListener('click', () => {
        qsa('.product-thumb').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        if (mainImage && thumb.dataset.image) {
          mainImage.src = thumb.dataset.image;
          mainImage.style.transform = '';
          mainImage.style.transformOrigin = '';
        }
      }));
    }

    initProductGallerySlider();
    initProductZoom();
    initProductImageLightbox();
    initPredictiveSearch();

  };

  const GVFG_FALLBACK_PAGES = {
    '/pages/about-us': { title: 'About Us', templateId: 'gvfgAboutTemplate', policy: false },
    '/pages/privacy-policy': { title: 'Privacy Policy', templateId: 'gvfgPrivacyTemplate', policy: true },
    '/pages/terms-and-conditions': { title: 'Terms and Conditions', templateId: 'gvfgTermsTemplate', policy: false },
    '/pages/refund-policy': { title: 'Refund Policy', templateId: 'gvfgRefundTemplate', policy: true },
    '/pages/shipping-policy': { title: 'Shipping Policy', templateId: 'gvfgShippingTemplate', policy: false },
    '/pages/return-exchange-policy': { title: 'Return & Exchange Policy', templateId: 'gvfgReturnExchangeTemplate', policy: true },
    '/pages/faqs': { title: "FAQ's", templateId: 'gvfgFaqsTemplate', policy: false },
    '/pages/condition-guide': { title: 'Condition Guide', templateId: 'gvfgConditionGuideTemplate', policy: false },
    '/pages/client-reviews': { title: 'Client Reviews', templateId: 'gvfgClientReviewsTemplate', policy: false },
    '/pages/wishlist': { title: 'My Wishlist', templateId: 'gvfgWishlistTemplate', policy: false, wishlist: true },
    '/pages/women-winter-wear': { title: 'Women Winter Wear', templateId: 'gvfgWomenWinterTemplate', policy: false },
    '/pages/mens-winter-wear': { title: "Men's Winter Wear", templateId: 'gvfgMensWinterTemplate', policy: false },
    '/pages/kids-winter-wear': { title: 'Kids Winter Wear', templateId: 'gvfgKidsWinterTemplate', policy: false },
  };

  const initFallbackPages = () => {
    const path = (window.location.pathname || '').replace(/\/+$/, '').toLowerCase();
    const page = GVFG_FALLBACK_PAGES[path];
    if (!page) return;
    const main = document.getElementById('MainContent');
    const template = document.getElementById(page.templateId);
    if (!main || !template) return;

    const shopName = (document.querySelector('meta[property="og:site_name"]')?.content || 'GVFG').trim();

    /* About Us / Terms: full-width custom pages — never wrap in .container */
    if (path === '/pages/about-us') {
      if (main.querySelector('.gvfg-about')) {
        document.body.classList.remove('template-404');
        document.body.classList.add('template-about-us');
        if (typeof window.gvfgInitAboutPage === 'function') window.gvfgInitAboutPage(true);
        return;
      }
      document.body.classList.remove('template-404');
      document.body.classList.add('template-about-us');
      main.innerHTML = template.innerHTML;
      document.title = `${page.title} \u2013 ${shopName}`;
      if (typeof window.gvfgInitAboutPage === 'function') window.gvfgInitAboutPage(true);
      return;
    }

    if (path === '/pages/terms-and-conditions') {
      if (main.querySelector('.gvfg-terms')) {
        document.body.classList.remove('template-404');
        document.body.classList.add('template-terms-and-conditions');
        if (typeof window.gvfgInitTermsPage === 'function') window.gvfgInitTermsPage(true);
        return;
      }
      document.body.classList.remove('template-404');
      document.body.classList.add('template-terms-and-conditions');
      main.innerHTML = template.innerHTML;
      document.title = `${page.title} \u2013 ${shopName}`;
      if (typeof window.gvfgInitTermsPage === 'function') window.gvfgInitTermsPage(true);
      return;
    }

    if (path === '/pages/shipping-policy') {
      if (main.querySelector('.gvfg-ship')) {
        document.body.classList.remove('template-404');
        document.body.classList.add('template-shipping-policy');
        if (typeof window.gvfgInitShippingPage === 'function') window.gvfgInitShippingPage(true);
        return;
      }
      document.body.classList.remove('template-404');
      document.body.classList.add('template-shipping-policy');
      main.innerHTML = template.innerHTML;
      document.title = `${page.title} \u2013 ${shopName}`;
      if (typeof window.gvfgInitShippingPage === 'function') window.gvfgInitShippingPage(true);
      return;
    }

    if (path === '/pages/condition-guide') {
      if (main.querySelector('.gvfg-cond')) {
        document.body.classList.remove('template-404');
        document.body.classList.add('template-condition-guide');
        if (typeof window.gvfgInitConditionPage === 'function') window.gvfgInitConditionPage(true);
        return;
      }
      document.body.classList.remove('template-404');
      document.body.classList.add('template-condition-guide');
      main.innerHTML = template.innerHTML;
      document.title = `${page.title} \u2013 ${shopName}`;
      if (typeof window.gvfgInitConditionPage === 'function') window.gvfgInitConditionPage(true);
      return;
    }

    if (path === '/pages/faqs') {
      if (main.querySelector('.gvfg-faq')) {
        document.body.classList.remove('template-404');
        document.body.classList.add('template-faqs');
        if (typeof window.gvfgInitFaqsPage === 'function') window.gvfgInitFaqsPage(true);
        return;
      }
      document.body.classList.remove('template-404');
      document.body.classList.add('template-faqs');
      main.innerHTML = template.innerHTML;
      document.title = `${page.title} \u2013 ${shopName}`;
      if (typeof window.gvfgInitFaqsPage === 'function') window.gvfgInitFaqsPage(true);
      return;
    }

    if (main.querySelector('.page-body')?.innerHTML === template.innerHTML) {
      if (page.wishlist) initWishlistPage();
      return;
    }
    document.body.classList.remove('template-404');
    const policyClass = page.policy ? ' page-content--policy' : '';
    const policyTitleClass = page.policy ? ' policy-page-title' : '';
    const policyBodyClass = page.policy ? ' policy-page-body' : '';
    const pageClass = page.wishlist ? ' wishlist-page' : '';
    main.innerHTML = `
      <section class="page-content${policyClass}${pageClass}">
        <div class="container">
          <h1 class="${policyTitleClass.trim()}">${page.title}</h1>
          <div class="rte page-body${policyBodyClass}">${template.innerHTML}</div>
        </div>
      </section>`;
    document.title = `${page.title} \u2013 ${shopName}`;
    if (page.wishlist) initWishlistPage();
  };

  const initTrustHub = (root = document) => {
    qsa('[data-trust-review-slider]', root).forEach((slider) => {
      if (slider.dataset.trustReady) return;
      slider.dataset.trustReady = '1';
      const slides = qsa('[data-trust-review-slide]', slider);
      const dots = qsa('[data-trust-review-dot]', slider);
      if (!slides.length) return;
      let idx = 0;
      let timer = null;

      const show = (next) => {
        idx = (next + slides.length) % slides.length;
        slides.forEach((s, i) => s.classList.toggle('is-active', i === idx));
        dots.forEach((d, i) => {
          const active = i === idx;
          d.classList.toggle('is-active', active);
          d.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          show(parseInt(dot.dataset.trustReviewDot, 10) || 0);
          if (timer?.stop) timer.stop();
          timer = createVisibilityInterval(() => show(idx + 1), 6000);
        });
      });

      if (slides.length > 1) {
        timer = createVisibilityInterval(() => show(idx + 1), 6000);
      }
    });

    qsa('[data-trust-condition-tabs]', root).forEach((tabs) => {
      if (tabs.dataset.trustReady) return;
      tabs.dataset.trustReady = '1';
      const hub = tabs.closest('.gvfg-trust-conditions');
      const panels = hub ? qsa('[data-condition-panel]', hub) : [];
      qsa('[data-condition]', tabs).forEach((tab) => {
        tab.addEventListener('click', () => {
          const id = tab.getAttribute('data-condition');
          qsa('[data-condition]', tabs).forEach((t) => {
            const active = t === tab;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          panels.forEach((panel) => {
            const active = panel.getAttribute('data-condition-panel') === id;
            panel.classList.toggle('is-active', active);
            panel.hidden = !active;
          });
        });
      });
    });
  };

  const initHomeReveal = () => {
    const items = document.querySelectorAll('.gvfg-home-reveal');
    if (!items.length) return;

    const show = (el) => el.classList.add('is-visible');

    if (!('IntersectionObserver' in window)) {
      items.forEach(show);
      return;
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          show(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -24px 0px' });

    items.forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.92) show(el);
      io.observe(el);
    });
  };

  const runIdle = (fn) => {
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(fn, { timeout: 2500 });
    } else {
      setTimeout(fn, 0);
    }
  };

  /** Load Instagram (or other) iframes only when near viewport — big network win */
  const initLazyIframes = (root = document) => {
    const iframes = qsa('iframe[data-src]', root);
    if (!iframes.length) return;
    const load = (el) => {
      const src = el.getAttribute('data-src');
      if (!src) return;
      el.src = src;
      el.removeAttribute('data-src');
    };
    if (!('IntersectionObserver' in window)) {
      iframes.forEach(load);
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        load(entry.target);
        io.unobserve(entry.target);
      });
    }, { rootMargin: '240px 0px', threshold: 0.01 });
    iframes.forEach((el) => io.observe(el));
  };

  document.addEventListener('DOMContentLoaded', () => {
    // Prevent duplicate listeners if a browser/app layer attempts to load this asset twice.
    if (window.__gvfgThemeBooted) return;
    window.__gvfgThemeBooted = true;
    initFallbackPages();
    initTitleSearch();
    initUI();
    initAnnouncements();
    initCartDrawer();
    initCardAddToCart();
    initSliders();
    initLazyIframes();
    initTrustHub();
    runIdle(() => {
      initHomeReveal();
      fetchCart().then(cart => syncCartAddButtons(cart)).catch(() => {});
      initQuickView();
      initWishlist();
      initCartPhone();
      initCartPage();
      initVariantPicker();
      initProductForm();
      initBuyNow();
      seedVariantInventoryCache();
      initCollectionFilters();
      initCollectionPage();
      initProductPage();
      initRecentlyViewed();
      initRecommendations();
    });
  });
})();
